// Auto-generated by Stone, do not modify.
var routes = {};

/**
 * Deletes the current user's profile photo.
 * Route attributes:
 *   scope: account_info.write
 * @function Dropbox#accountDeleteProfilePhoto
 * @arg {AccountDeleteProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AccountDeleteProfilePhotoResult>, DropboxResponseError.<AccountDeleteProfilePhotoError>>}
 */
routes.accountDeleteProfilePhoto = function (arg, options) {
  return this.request('account/delete_profile_photo', arg, 'user', 'api', 'rpc', 'account_info.write', options);
};

/**
 * This lovely endpoint gets the account photo of a given user.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#accountGetPhoto
 * @arg {AccountAccountPhotoGetArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AccountAccountPhotoGetResult>, DropboxResponseError.<AccountAccountPhotoGetError>>}
 */
routes.accountGetPhoto = function (arg, options) {
  return this.request('account/get_photo', arg, 'user', 'content', 'download', 'account_info.read', options);
};

/**
 * Sets a user's profile photo.
 * Route attributes:
 *   scope: account_info.write
 * @function Dropbox#accountSetProfilePhoto
 * @arg {AccountSetProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AccountSetProfilePhotoResult>, DropboxResponseError.<AccountSetProfilePhotoError>>}
 */
routes.accountSetProfilePhoto = function (arg, options) {
  return this.request('account/set_profile_photo', arg, 'user', 'api', 'rpc', 'account_info.write', options);
};

/**
 * Creates an OAuth 2.0 access token from the supplied OAuth 1.0 access token.
 * @function Dropbox#authTokenFromOauth1
 * @deprecated
 * @arg {AuthTokenFromOAuth1Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AuthTokenFromOAuth1Result>, DropboxResponseError.<AuthTokenFromOAuth1Error>>}
 */
routes.authTokenFromOauth1 = function (arg, options) {
  return this.request('auth/token/from_oauth1', arg, 'app', 'api', 'rpc', null, options);
};

/**
 * Disables the access token used to authenticate the call. If there is a
 * corresponding refresh token for the access token, this disables that refresh
 * token, as well as any other access tokens for that refresh token.
 * @function Dropbox#authTokenRevoke
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<void>>}
 */
routes.authTokenRevoke = function (options) {
  return this.request('auth/token/revoke', null, 'user', 'api', 'rpc', null, options);
};

/**
 * This endpoint performs App Authentication, validating the supplied app key
 * and secret, and returns the supplied string, to allow you to test your code
 * and connection to the Dropbox API. It has no other effect. If you receive an
 * HTTP 200 response with the supplied query, it indicates at least part of the
 * Dropbox API infrastructure is working and that the app key and secret valid.
 * @function Dropbox#checkApp
 * @arg {CheckEchoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<CheckEchoResult>, DropboxResponseError.<CheckEchoError>>}
 */
routes.checkApp = function (arg, options) {
  return this.request('check/app', arg, 'app', 'api', 'rpc', null, options);
};

/**
 * This endpoint performs User Authentication, validating the supplied access
 * token, and returns the supplied string, to allow you to test your code and
 * connection to the Dropbox API. It has no other effect. If you receive an HTTP
 * 200 response with the supplied query, it indicates at least part of the
 * Dropbox API infrastructure is working and that the access token is valid.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#checkUser
 * @arg {CheckEchoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<CheckEchoResult>, DropboxResponseError.<CheckEchoError>>}
 */
routes.checkUser = function (arg, options) {
  return this.request('check/user', arg, 'user', 'api', 'rpc', 'account_info.read', options);
};

/**
 * Removes all manually added contacts. You'll still keep contacts who are on
 * your team or who you imported. New contacts will be added when you share.
 * Route attributes:
 *   scope: contacts.write
 * @function Dropbox#contactsDeleteManualContacts
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<void>>}
 */
routes.contactsDeleteManualContacts = function (options) {
  return this.request('contacts/delete_manual_contacts', null, 'user', 'api', 'rpc', 'contacts.write', options);
};

/**
 * Removes manually added contacts from the given list.
 * Route attributes:
 *   scope: contacts.write
 * @function Dropbox#contactsDeleteManualContactsBatch
 * @arg {ContactsDeleteManualContactsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<ContactsDeleteManualContactsError>>}
 */
routes.contactsDeleteManualContactsBatch = function (arg, options) {
  return this.request('contacts/delete_manual_contacts_batch', arg, 'user', 'api', 'rpc', 'contacts.write', options);
};

/**
 * Add property groups to a Dropbox file. See templates/add_for_user or
 * templates/add_for_team to create new templates.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesAdd
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesAddPropertiesError>>}
 */
routes.filePropertiesPropertiesAdd = function (arg, options) {
  return this.request('file_properties/properties/add', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Overwrite property groups associated with a file. This endpoint should be
 * used instead of properties/update when property groups are being updated via
 * a "snapshot" instead of via a "delta". In other words, this endpoint will
 * delete all omitted fields from a property group, whereas properties/update
 * will only delete fields that are explicitly marked for deletion.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesOverwrite
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesInvalidPropertyGroupError>>}
 */
routes.filePropertiesPropertiesOverwrite = function (arg, options) {
  return this.request('file_properties/properties/overwrite', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Permanently removes the specified property group from the file. To remove
 * specific property field key value pairs, see properties/update. To update a
 * template, see templates/update_for_user or templates/update_for_team. To
 * remove a template, see templates/remove_for_user or
 * templates/remove_for_team.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesRemove
 * @arg {FilePropertiesRemovePropertiesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesRemovePropertiesError>>}
 */
routes.filePropertiesPropertiesRemove = function (arg, options) {
  return this.request('file_properties/properties/remove', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Search across property templates for particular property field values.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesPropertiesSearch
 * @arg {FilePropertiesPropertiesSearchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesPropertiesSearchResult>, DropboxResponseError.<FilePropertiesPropertiesSearchError>>}
 */
routes.filePropertiesPropertiesSearch = function (arg, options) {
  return this.request('file_properties/properties/search', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Once a cursor has been retrieved from properties/search, use this to paginate
 * through all search results.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesPropertiesSearchContinue
 * @arg {FilePropertiesPropertiesSearchContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesPropertiesSearchResult>, DropboxResponseError.<FilePropertiesPropertiesSearchContinueError>>}
 */
routes.filePropertiesPropertiesSearchContinue = function (arg, options) {
  return this.request('file_properties/properties/search/continue', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Add, update or remove properties associated with the supplied file and
 * templates. This endpoint should be used instead of properties/overwrite when
 * property groups are being updated via a "delta" instead of via a "snapshot" .
 * In other words, this endpoint will not delete any omitted fields from a
 * property group, whereas properties/overwrite will delete any fields that are
 * omitted from a property group.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesUpdate
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesUpdatePropertiesError>>}
 */
routes.filePropertiesPropertiesUpdate = function (arg, options) {
  return this.request('file_properties/properties/update', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Add a template associated with a team. See properties/add to add properties
 * to a file or folder. Note: this endpoint will create team-owned templates.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesAddForTeam
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */
routes.filePropertiesTemplatesAddForTeam = function (arg, options) {
  return this.request('file_properties/templates/add_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Add a template associated with a user. See properties/add to add properties
 * to a file. This endpoint can't be called on a team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesAddForUser
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */
routes.filePropertiesTemplatesAddForUser = function (arg, options) {
  return this.request('file_properties/templates/add_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Get the schema for a specified template.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesGetForTeam
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesGetForTeam = function (arg, options) {
  return this.request('file_properties/templates/get_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Get the schema for a specified template. This endpoint can't be called on a
 * team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesTemplatesGetForUser
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesGetForUser = function (arg, options) {
  return this.request('file_properties/templates/get_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_team.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesListForTeam
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesListForTeam = function (options) {
  return this.request('file_properties/templates/list_for_team', null, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_user. This endpoint can't be called on a team member or
 * admin's behalf.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesTemplatesListForUser
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesListForUser = function (options) {
  return this.request('file_properties/templates/list_for_user', null, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesRemoveForTeam
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesRemoveForTeam = function (arg, options) {
  return this.request('file_properties/templates/remove_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesRemoveForUser
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.filePropertiesTemplatesRemoveForUser = function (arg, options) {
  return this.request('file_properties/templates/remove_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Update a template associated with a team. This route can update the template
 * name, the template description and add optional properties to templates.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesUpdateForTeam
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesUpdateTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */
routes.filePropertiesTemplatesUpdateForTeam = function (arg, options) {
  return this.request('file_properties/templates/update_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Update a template associated with a user. This route can update the template
 * name, the template description and add optional properties to templates. This
 * endpoint can't be called on a team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesUpdateForUser
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesUpdateTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */
routes.filePropertiesTemplatesUpdateForUser = function (arg, options) {
  return this.request('file_properties/templates/update_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Returns the total number of file requests owned by this user. Includes both
 * open and closed file requests.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsCount
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsCountFileRequestsResult>, DropboxResponseError.<FileRequestsCountFileRequestsError>>}
 */
routes.fileRequestsCount = function (options) {
  return this.request('file_requests/count', null, 'user', 'api', 'rpc', 'file_requests.read', options);
};

/**
 * Creates a file request for this user.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsCreate
 * @arg {FileRequestsCreateFileRequestArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsCreateFileRequestError>>}
 */
routes.fileRequestsCreate = function (arg, options) {
  return this.request('file_requests/create', arg, 'user', 'api', 'rpc', 'file_requests.write', options);
};

/**
 * Delete a batch of closed file requests.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsDelete
 * @arg {FileRequestsDeleteFileRequestArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsDeleteFileRequestsResult>, DropboxResponseError.<FileRequestsDeleteFileRequestError>>}
 */
routes.fileRequestsDelete = function (arg, options) {
  return this.request('file_requests/delete', arg, 'user', 'api', 'rpc', 'file_requests.write', options);
};

/**
 * Delete all closed file requests owned by this user.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsDeleteAllClosed
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsDeleteAllClosedFileRequestsResult>, DropboxResponseError.<FileRequestsDeleteAllClosedFileRequestsError>>}
 */
routes.fileRequestsDeleteAllClosed = function (options) {
  return this.request('file_requests/delete_all_closed', null, 'user', 'api', 'rpc', 'file_requests.write', options);
};

/**
 * Returns the specified file request.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsGet
 * @arg {FileRequestsGetFileRequestArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsGetFileRequestError>>}
 */
routes.fileRequestsGet = function (arg, options) {
  return this.request('file_requests/get', arg, 'user', 'api', 'rpc', 'file_requests.read', options);
};

/**
 * Returns a list of file requests owned by this user. For apps with the app
 * folder permission, this will only return file requests with destinations in
 * the app folder.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsList
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsResult>, DropboxResponseError.<FileRequestsListFileRequestsError>>}
 */
routes.fileRequestsList = function (options) {
  return this.request('file_requests/list', null, 'user', 'api', 'rpc', 'file_requests.read', options);
};

/**
 * Returns a list of file requests owned by this user. For apps with the app
 * folder permission, this will only return file requests with destinations in
 * the app folder.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsListV2
 * @arg {FileRequestsListFileRequestsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsV2Result>, DropboxResponseError.<FileRequestsListFileRequestsError>>}
 */
routes.fileRequestsListV2 = function (arg, options) {
  return this.request('file_requests/list_v2', arg, 'user', 'api', 'rpc', 'file_requests.read', options);
};

/**
 * Once a cursor has been retrieved from list_v2, use this to paginate through
 * all file requests. The cursor must come from a previous call to list_v2 or
 * list/continue.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsListContinue
 * @arg {FileRequestsListFileRequestsContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsV2Result>, DropboxResponseError.<FileRequestsListFileRequestsContinueError>>}
 */
routes.fileRequestsListContinue = function (arg, options) {
  return this.request('file_requests/list/continue', arg, 'user', 'api', 'rpc', 'file_requests.read', options);
};

/**
 * Update a file request.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsUpdate
 * @arg {FileRequestsUpdateFileRequestArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsUpdateFileRequestError>>}
 */
routes.fileRequestsUpdate = function (arg, options) {
  return this.request('file_requests/update', arg, 'user', 'api', 'rpc', 'file_requests.write', options);
};

/**
 * Returns the metadata for a file or folder. This is an alpha endpoint
 * compatible with the properties API. Note: Metadata for the root folder is
 * unsupported.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesAlphaGetMetadata
 * @deprecated
 * @arg {FilesAlphaGetMetadataArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesAlphaGetMetadataError>>}
 */
routes.filesAlphaGetMetadata = function (arg, options) {
  return this.request('files/alpha/get_metadata', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Create a new file with the contents provided in the request. Note that the
 * behavior of this alpha endpoint is unstable and subject to change. Do not use
 * this to upload a file larger than 150 MiB. Instead, create an upload session
 * with upload_session/start.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesAlphaUpload
 * @deprecated
 * @arg {FilesUploadArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadError>>}
 */
routes.filesAlphaUpload = function (arg, options) {
  return this.request('files/alpha/upload', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopy
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesRelocationError>>}
 */
routes.filesCopy = function (arg, options) {
  return this.request('files/copy', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationResult>, DropboxResponseError.<FilesRelocationError>>}
 */
routes.filesCopyV2 = function (arg, options) {
  return this.request('files/copy_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Copy multiple files or folders to different locations at once in the user's
 * Dropbox. This route will return job ID immediately and do the async copy job
 * in background. Please use copy_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatch
 * @deprecated
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchLaunch>, DropboxResponseError.<void>>}
 */
routes.filesCopyBatch = function (arg, options) {
  return this.request('files/copy_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Copy multiple files or folders to different locations at once in the user's
 * Dropbox. This route will replace copy_batch. The main difference is this
 * route will return status for each entry, while copy_batch raises failure if
 * any entry fails. This route will either finish synchronously, or return a job
 * ID and do the async copy job in background. Please use copy_batch/check_v2 to
 * check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchV2
 * @arg {Object} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2Launch>, DropboxResponseError.<void>>}
 */
routes.filesCopyBatchV2 = function (arg, options) {
  return this.request('files/copy_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for copy_batch. If success, it
 * returns list of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchCheck
 * @deprecated
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesCopyBatchCheck = function (arg, options) {
  return this.request('files/copy_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for copy_batch_v2. It returns list
 * of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchCheckV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2JobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesCopyBatchCheckV2 = function (arg, options) {
  return this.request('files/copy_batch/check_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Get a copy reference to a file or folder. This reference string can be used
 * to save that file or folder to another user's Dropbox by passing it to
 * copy_reference/save.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyReferenceGet
 * @arg {FilesGetCopyReferenceArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesGetCopyReferenceResult>, DropboxResponseError.<FilesGetCopyReferenceError>>}
 */
routes.filesCopyReferenceGet = function (arg, options) {
  return this.request('files/copy_reference/get', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Save a copy reference returned by copy_reference/get to the user's Dropbox.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyReferenceSave
 * @arg {FilesSaveCopyReferenceArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSaveCopyReferenceResult>, DropboxResponseError.<FilesSaveCopyReferenceError>>}
 */
routes.filesCopyReferenceSave = function (arg, options) {
  return this.request('files/copy_reference/save', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Create a folder at a given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolder
 * @deprecated
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFolderMetadata>, DropboxResponseError.<FilesCreateFolderError>>}
 */
routes.filesCreateFolder = function (arg, options) {
  return this.request('files/create_folder', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Create a folder at a given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderV2
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderResult>, DropboxResponseError.<FilesCreateFolderError>>}
 */
routes.filesCreateFolderV2 = function (arg, options) {
  return this.request('files/create_folder_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Create multiple folders at once. This route is asynchronous for large
 * batches, which returns a job ID immediately and runs the create folder batch
 * asynchronously. Otherwise, creates the folders and returns the result
 * synchronously for smaller inputs. You can force asynchronous behaviour by
 * using the CreateFolderBatchArg.force_async flag.  Use
 * create_folder_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderBatch
 * @arg {FilesCreateFolderBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderBatchLaunch>, DropboxResponseError.<void>>}
 */
routes.filesCreateFolderBatch = function (arg, options) {
  return this.request('files/create_folder_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for create_folder_batch. If
 * success, it returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesCreateFolderBatchCheck = function (arg, options) {
  return this.request('files/create_folder_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDelete
 * @deprecated
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesDeleteError>>}
 */
routes.filesDelete = function (arg, options) {
  return this.request('files/delete', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteV2
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesDeleteResult>, DropboxResponseError.<FilesDeleteError>>}
 */
routes.filesDeleteV2 = function (arg, options) {
  return this.request('files/delete_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Delete multiple files/folders at once. This route is asynchronous, which
 * returns a job ID immediately and runs the delete batch asynchronously. Use
 * delete_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteBatch
 * @arg {FilesDeleteBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesDeleteBatchLaunch>, DropboxResponseError.<void>>}
 */
routes.filesDeleteBatch = function (arg, options) {
  return this.request('files/delete_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for delete_batch. If success, it
 * returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesDeleteBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesDeleteBatchCheck = function (arg, options) {
  return this.request('files/delete_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Download a file from a user's Dropbox.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesDownload
 * @arg {FilesDownloadArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesDownloadError>>}
 */
routes.filesDownload = function (arg, options) {
  return this.request('files/download', arg, 'user', 'content', 'download', 'files.content.read', options);
};

/**
 * Download a folder from the user's Dropbox, as a zip file. The folder must be
 * less than 20 GB in size and any single file within must be less than 4 GB in
 * size. The resulting zip must have fewer than 10,000 total file and folder
 * entries, including the top level folder. The input cannot be a single file.
 * Note: this endpoint does not support HTTP range requests.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesDownloadZip
 * @arg {FilesDownloadZipArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesDownloadZipResult>, DropboxResponseError.<FilesDownloadZipError>>}
 */
routes.filesDownloadZip = function (arg, options) {
  return this.request('files/download_zip', arg, 'user', 'content', 'download', 'files.content.read', options);
};

/**
 * Export a file from a user's Dropbox. This route only supports exporting files
 * that cannot be downloaded directly and whose ExportResult.file_metadata has
 * ExportInfo.export_as populated.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesExport
 * @arg {FilesExportArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesExportResult>, DropboxResponseError.<FilesExportError>>}
 */
routes.filesExport = function (arg, options) {
  return this.request('files/export', arg, 'user', 'content', 'download', 'files.content.read', options);
};

/**
 * Return the lock metadata for the given list of paths.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetFileLockBatch
 * @arg {FilesLockFileBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */
routes.filesGetFileLockBatch = function (arg, options) {
  return this.request('files/get_file_lock_batch', arg, 'user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the metadata for a file or folder. Note: Metadata for the root folder
 * is unsupported.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesGetMetadata
 * @arg {FilesGetMetadataArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesGetMetadataError>>}
 */
routes.filesGetMetadata = function (arg, options) {
  return this.request('files/get_metadata', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Get a preview for a file. Currently, PDF previews are generated for files
 * with the following extensions: .ai, .doc, .docm, .docx, .eps, .gdoc,
 * .gslides, .odp, .odt, .pps, .ppsm, .ppsx, .ppt, .pptm, .pptx, .rtf. HTML
 * previews are generated for .csv, .ods, .xls, .xlsm, .gsheet, .xlsx. Other
 * formats will return an unsupported extension error.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetPreview
 * @arg {FilesPreviewArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesPreviewError>>}
 */
routes.filesGetPreview = function (arg, options) {
  return this.request('files/get_preview', arg, 'user', 'content', 'download', 'files.content.read', options);
};

/**
 * Get a temporary link to stream content of a file. This link will expire in
 * four hours and afterwards you will get 410 Gone. This URL should not be used
 * to display content directly in the browser. The Content-Type of the link is
 * determined automatically by the file's mime type.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetTemporaryLink
 * @arg {FilesGetTemporaryLinkArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesGetTemporaryLinkResult>, DropboxResponseError.<FilesGetTemporaryLinkError>>}
 */
routes.filesGetTemporaryLink = function (arg, options) {
  return this.request('files/get_temporary_link', arg, 'user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Get a one-time use temporary upload link to upload a file to a Dropbox
 * location.  This endpoint acts as a delayed upload(). The returned temporary
 * upload link may be used to make a POST request with the data to be uploaded.
 * The upload will then be perfomed with the CommitInfo previously provided to
 * getTemporaryUploadLink() but evaluated only upon consumption. Hence, errors
 * stemming from invalid CommitInfo with respect to the state of the user's
 * Dropbox will only be communicated at consumption time. Additionally, these
 * errors are surfaced as generic HTTP 409 Conflict responses, potentially
 * hiding issue details. The maximum temporary upload link duration is 4 hours.
 * Upon consumption or expiration, a new link will have to be generated.
 * Multiple links may exist for a specific upload path at any given time.  The
 * POST request on the temporary upload link must have its Content-Type set to
 * "application/octet-stream".  Example temporary upload link consumption
 * request:  curl -X POST
 * https://content.dropboxapi.com/apitul/1/bNi2uIYF51cVBND --header
 * "Content-Type: application/octet-stream" --data-binary @local_file.txt  A
 * successful temporary upload link consumption request returns the content hash
 * of the uploaded data in JSON format. Example successful temporary upload link
 * consumption response: {"content-hash":
 * "599d71033d700ac892a0e48fa61b125d2f5994"}  An unsuccessful temporary upload
 * link consumption request returns any of the following status codes:  HTTP 400
 * Bad Request: Content-Type is not one of application/octet-stream and
 * text/plain or request is invalid. HTTP 409 Conflict: The temporary upload
 * link does not exist or is currently unavailable, the upload failed, or
 * another error happened. HTTP 410 Gone: The temporary upload link is expired
 * or consumed. Example unsuccessful temporary upload link consumption response:
 * Temporary upload link has been recently consumed.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesGetTemporaryUploadLink
 * @arg {FilesGetTemporaryUploadLinkArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesGetTemporaryUploadLinkResult>, DropboxResponseError.<void>>}
 */
routes.filesGetTemporaryUploadLink = function (arg, options) {
  return this.request('files/get_temporary_upload_link', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Get a thumbnail for an image. This method currently supports files with the
 * following file extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp.
 * Photos that are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnail
 * @arg {FilesThumbnailArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesThumbnailError>>}
 */
routes.filesGetThumbnail = function (arg, options) {
  return this.request('files/get_thumbnail', arg, 'user', 'content', 'download', 'files.content.read', options);
};

/**
 * Get a thumbnail for an image. This method currently supports files with the
 * following file extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp.
 * Photos that are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnailV2
 * @arg {FilesThumbnailV2Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesPreviewResult>, DropboxResponseError.<FilesThumbnailV2Error>>}
 */
routes.filesGetThumbnailV2 = function (arg, options) {
  return this.request('files/get_thumbnail_v2', arg, 'app, user', 'content', 'download', 'files.content.read', options);
};

/**
 * Get thumbnails for a list of images. We allow up to 25 thumbnails in a single
 * batch. This method currently supports files with the following file
 * extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp. Photos that
 * are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnailBatch
 * @arg {FilesGetThumbnailBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesGetThumbnailBatchResult>, DropboxResponseError.<FilesGetThumbnailBatchError>>}
 */
routes.filesGetThumbnailBatch = function (arg, options) {
  return this.request('files/get_thumbnail_batch', arg, 'user', 'content', 'rpc', 'files.content.read', options);
};

/**
 * Starts returning the contents of a folder. If the result's
 * ListFolderResult.has_more field is true, call list_folder/continue with the
 * returned ListFolderResult.cursor to retrieve more entries. If you're using
 * ListFolderArg.recursive set to true to keep a local cache of the contents of
 * a Dropbox account, iterate through each entry in order and process them as
 * follows to keep your local state in sync: For each FileMetadata, store the
 * new entry at the given path in your local state. If the required parent
 * folders don't exist yet, create them. If there's already something else at
 * the given path, replace it and remove all its children. For each
 * FolderMetadata, store the new entry at the given path in your local state. If
 * the required parent folders don't exist yet, create them. If there's already
 * something else at the given path, replace it but leave the children as they
 * are. Check the new entry's FolderSharingInfo.read_only and set all its
 * children's read-only statuses to match. For each DeletedMetadata, if your
 * local state has something at the given path, remove it and all its children.
 * If there's nothing at the given path, ignore this entry. Note:
 * auth.RateLimitError may be returned if multiple list_folder or
 * list_folder/continue calls with same parameters are made simultaneously by
 * same API app for same user. If your app implements retry logic, please hold
 * off the retry until the previous request finishes.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolder
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesListFolderResult>, DropboxResponseError.<FilesListFolderError>>}
 */
routes.filesListFolder = function (arg, options) {
  return this.request('files/list_folder', arg, 'app, user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Once a cursor has been retrieved from list_folder, use this to paginate
 * through all files and retrieve updates to the folder, following the same
 * rules as documented for list_folder.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderContinue
 * @arg {FilesListFolderContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesListFolderResult>, DropboxResponseError.<FilesListFolderContinueError>>}
 */
routes.filesListFolderContinue = function (arg, options) {
  return this.request('files/list_folder/continue', arg, 'app, user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * A way to quickly get a cursor for the folder's state. Unlike list_folder,
 * list_folder/get_latest_cursor doesn't return any entries. This endpoint is
 * for app which only needs to know about new files and modifications and
 * doesn't need to know about files that already exist in Dropbox.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderGetLatestCursor
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesListFolderGetLatestCursorResult>, DropboxResponseError.<FilesListFolderError>>}
 */
routes.filesListFolderGetLatestCursor = function (arg, options) {
  return this.request('files/list_folder/get_latest_cursor', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * A longpoll endpoint to wait for changes on an account. In conjunction with
 * list_folder/continue, this call gives you a low-latency way to monitor an
 * account for file changes. The connection will block until there are changes
 * available or a timeout occurs. This endpoint is useful mostly for client-side
 * apps.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderLongpoll
 * @arg {FilesListFolderLongpollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesListFolderLongpollResult>, DropboxResponseError.<FilesListFolderLongpollError>>}
 */
routes.filesListFolderLongpoll = function (arg, options) {
  return this.request('files/list_folder/longpoll', arg, 'noauth', 'notify', 'rpc', 'files.metadata.read', options);
};

/**
 * Returns revisions for files based on a file path or a file id. The file path
 * or file id is identified from the latest file entry at the given file path or
 * id. This end point allows your app to query either by file path or file id by
 * setting the mode parameter appropriately. In the ListRevisionsMode.path
 * (default) mode, all revisions at the same file path as the latest file entry
 * are returned. If revisions with the same file id are desired, then mode must
 * be set to ListRevisionsMode.id. The ListRevisionsMode.id mode is useful to
 * retrieve revisions for a given file across moves or renames.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListRevisions
 * @arg {FilesListRevisionsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesListRevisionsResult>, DropboxResponseError.<FilesListRevisionsError>>}
 */
routes.filesListRevisions = function (arg, options) {
  return this.request('files/list_revisions', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Lock the files at the given paths. A locked file will be writable only by the
 * lock holder. A successful response indicates that the file has been locked.
 * Returns a list of the locked file paths and their metadata after this
 * operation.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesLockFileBatch
 * @arg {FilesLockFileBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */
routes.filesLockFileBatch = function (arg, options) {
  return this.request('files/lock_file_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMove
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesRelocationError>>}
 */
routes.filesMove = function (arg, options) {
  return this.request('files/move', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved. Note that we do not
 * currently support case-only renaming.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationResult>, DropboxResponseError.<FilesRelocationError>>}
 */
routes.filesMoveV2 = function (arg, options) {
  return this.request('files/move_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Move multiple files or folders to different locations at once in the user's
 * Dropbox. This route will return job ID immediately and do the async moving
 * job in background. Please use move_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatch
 * @deprecated
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchLaunch>, DropboxResponseError.<void>>}
 */
routes.filesMoveBatch = function (arg, options) {
  return this.request('files/move_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Move multiple files or folders to different locations at once in the user's
 * Dropbox. Note that we do not currently support case-only renaming. This route
 * will replace move_batch. The main difference is this route will return status
 * for each entry, while move_batch raises failure if any entry fails. This
 * route will either finish synchronously, or return a job ID and do the async
 * move job in background. Please use move_batch/check_v2 to check the job
 * status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchV2
 * @arg {FilesMoveBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2Launch>, DropboxResponseError.<void>>}
 */
routes.filesMoveBatchV2 = function (arg, options) {
  return this.request('files/move_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for move_batch. If success, it
 * returns list of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchCheck
 * @deprecated
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesMoveBatchCheck = function (arg, options) {
  return this.request('files/move_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for move_batch_v2. It returns list
 * of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchCheckV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2JobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesMoveBatchCheckV2 = function (arg, options) {
  return this.request('files/move_batch/check_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Creates a new Paper doc with the provided content.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesPaperCreate
 * @arg {FilesPaperCreateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesPaperCreateResult>, DropboxResponseError.<FilesPaperCreateError>>}
 */
routes.filesPaperCreate = function (arg, options) {
  return this.request('files/paper/create', arg, 'user', 'api', 'upload', 'files.content.write', options);
};

/**
 * Updates an existing Paper doc with the provided content.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesPaperUpdate
 * @arg {FilesPaperUpdateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesPaperUpdateResult>, DropboxResponseError.<FilesPaperUpdateError>>}
 */
routes.filesPaperUpdate = function (arg, options) {
  return this.request('files/paper/update', arg, 'user', 'api', 'upload', 'files.content.write', options);
};

/**
 * Permanently delete the file or folder at a given path (see
 * https://www.dropbox.com/en/help/40). If the given file or folder is not yet
 * deleted, this route will first delete it. It is possible for this route to
 * successfully delete, then fail to permanently delete. Note: This endpoint is
 * only available for Dropbox Business apps.
 * Route attributes:
 *   scope: files.permanent_delete
 * @function Dropbox#filesPermanentlyDelete
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesDeleteError>>}
 */
routes.filesPermanentlyDelete = function (arg, options) {
  return this.request('files/permanently_delete', arg, 'user', 'api', 'rpc', 'files.permanent_delete', options);
};

/**
 * Add property groups to a Dropbox file. See templates/add_for_user or
 * templates/add_for_team to create new templates.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesAdd
 * @deprecated
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesAddPropertiesError>>}
 */
routes.filesPropertiesAdd = function (arg, options) {
  return this.request('files/properties/add', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Overwrite property groups associated with a file. This endpoint should be
 * used instead of properties/update when property groups are being overwritten
 * rather than updated via a "delta".
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesOverwrite
 * @deprecated
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesInvalidPropertyGroupError>>}
 */
routes.filesPropertiesOverwrite = function (arg, options) {
  return this.request('files/properties/overwrite', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Add, update or remove properties associated with the supplied file and
 * templates. This endpoint should be used instead of properties/overwrite when
 * property groups are being updated via a "delta" instead of overwriting all
 * properties of a file.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesUpdate
 * @deprecated
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesUpdatePropertiesError>>}
 */
routes.filesPropertiesUpdate = function (arg, options) {
  return this.request('files/properties/update', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Restore a specific revision of a file to the given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesRestore
 * @arg {FilesRestoreArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesRestoreError>>}
 */
routes.filesRestore = function (arg, options) {
  return this.request('files/restore', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Save the data from a specified URL into a file in user's Dropbox. Note that
 * the transfer from the URL must complete within 15 minutes, or the operation
 * will time out and the job will fail.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesSaveUrl
 * @arg {FilesSaveUrlArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSaveUrlResult>, DropboxResponseError.<FilesSaveUrlError>>}
 */
routes.filesSaveUrl = function (arg, options) {
  return this.request('files/save_url', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Check the status of a save_url job.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesSaveUrlCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSaveUrlJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesSaveUrlCheckJobStatus = function (arg, options) {
  return this.request('files/save_url/check_job_status', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Searches for files and folders. Note: Recent changes will be reflected in
 * search results within a few seconds and older revisions of existing files may
 * still match your query for up to a few days.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearch
 * @deprecated
 * @arg {FilesSearchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSearchResult>, DropboxResponseError.<FilesSearchError>>}
 */
routes.filesSearch = function (arg, options) {
  return this.request('files/search', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Searches for files and folders. Note: search_v2 along with search/continue_v2
 * can only be used to retrieve a maximum of 10,000 matches. Recent changes may
 * not immediately be reflected in search results due to a short delay in
 * indexing. Duplicate results may be returned across pages. Some results may
 * not be returned.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearchV2
 * @arg {FilesSearchV2Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSearchV2Result>, DropboxResponseError.<FilesSearchError>>}
 */
routes.filesSearchV2 = function (arg, options) {
  return this.request('files/search_v2', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Fetches the next page of search results returned from search_v2. Note:
 * search_v2 along with search/continue_v2 can only be used to retrieve a
 * maximum of 10,000 matches. Recent changes may not immediately be reflected in
 * search results due to a short delay in indexing. Duplicate results may be
 * returned across pages. Some results may not be returned.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearchContinueV2
 * @arg {FilesSearchV2ContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesSearchV2Result>, DropboxResponseError.<FilesSearchError>>}
 */
routes.filesSearchContinueV2 = function (arg, options) {
  return this.request('files/search/continue_v2', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Add a tag to an item. A tag is a string. The strings are automatically
 * converted to lowercase letters. No more than 20 tags can be added to a given
 * item.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesTagsAdd
 * @arg {FilesAddTagArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesAddTagError>>}
 */
routes.filesTagsAdd = function (arg, options) {
  return this.request('files/tags/add', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Get list of tags assigned to items.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesTagsGet
 * @arg {FilesGetTagsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesGetTagsResult>, DropboxResponseError.<FilesBaseTagError>>}
 */
routes.filesTagsGet = function (arg, options) {
  return this.request('files/tags/get', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Remove a tag from an item.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesTagsRemove
 * @arg {FilesRemoveTagArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesRemoveTagError>>}
 */
routes.filesTagsRemove = function (arg, options) {
  return this.request('files/tags/remove', arg, 'user', 'api', 'rpc', 'files.metadata.write', options);
};

/**
 * Unlock the files at the given paths. A locked file can only be unlocked by
 * the lock holder or, if a business account, a team admin. A successful
 * response indicates that the file has been unlocked. Returns a list of the
 * unlocked file paths and their metadata after this operation.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUnlockFileBatch
 * @arg {FilesUnlockFileBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */
routes.filesUnlockFileBatch = function (arg, options) {
  return this.request('files/unlock_file_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Create a new file with the contents provided in the request. Do not use this
 * to upload a file larger than 150 MiB. Instead, create an upload session with
 * upload_session/start. Calls to this endpoint will count as data transport
 * calls for any Dropbox Business teams with a limit on the number of data
 * transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUpload
 * @arg {FilesUploadArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadError>>}
 */
routes.filesUpload = function (arg, options) {
  return this.request('files/upload', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Append more data to an upload session. A single request should not upload
 * more than 150 MiB. The maximum size of a file one can upload to an upload
 * session is 2^41 - 2^22 (2,199,019,061,248) bytes. Calls to this endpoint will
 * count as data transport calls for any Dropbox Business teams with a limit on
 * the number of data transport calls allowed per month. For more information,
 * see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionAppend
 * @deprecated
 * @arg {FilesUploadSessionCursor} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesUploadSessionAppendError>>}
 */
routes.filesUploadSessionAppend = function (arg, options) {
  return this.request('files/upload_session/append', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Append more data to an upload session. When the parameter close is set, this
 * call will close the session. A single request should not upload more than 150
 * MiB. The maximum size of a file one can upload to an upload session is 2^41 -
 * 2^22 (2,199,019,061,248) bytes. Calls to this endpoint will count as data
 * transport calls for any Dropbox Business teams with a limit on the number of
 * data transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionAppendV2
 * @arg {FilesUploadSessionAppendArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesUploadSessionAppendError>>}
 */
routes.filesUploadSessionAppendV2 = function (arg, options) {
  return this.request('files/upload_session/append_v2', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Append more data to multiple upload sessions. Each piece of file content to
 * append to each upload session should be concatenated in the request body, in
 * the order delineated by UploadSessionAppendBatchArg.entries and their
 * individual lengths indicated by UploadSessionAppendBatchArgEntry.length. A
 * single request should not upload more than 150 MiB. The maximum size of a
 * file one can upload to an upload session is 2^41 - 2^22 (2,199,019,061,248)
 * bytes. Calls to this endpoint will count as data transport calls for any
 * Dropbox Business teams with a limit on the number of data transport calls
 * allowed per month. For more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionAppendBatch
 * @arg {FilesUploadSessionAppendBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionAppendBatchResult>, DropboxResponseError.<FilesUploadSessionAppendBatchError>>}
 */
routes.filesUploadSessionAppendBatch = function (arg, options) {
  return this.request('files/upload_session/append_batch', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Finish an upload session and save the uploaded data to the given file path. A
 * single request should not upload more than 150 MiB. The maximum size of a
 * file one can upload to an upload session is 2^41 - 2^22 (2,199,019,061,248)
 * bytes. Calls to this endpoint will count as data transport calls for any
 * Dropbox Business teams with a limit on the number of data transport calls
 * allowed per month. For more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinish
 * @arg {FilesUploadSessionFinishArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadSessionFinishError>>}
 */
routes.filesUploadSessionFinish = function (arg, options) {
  return this.request('files/upload_session/finish', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * This route helps you commit many files at once into a user's Dropbox. Use
 * upload_session/start and upload_session/append_v2 to upload file contents. We
 * recommend uploading many files in parallel to increase throughput. Once the
 * file contents have been uploaded, rather than calling upload_session/finish,
 * use this route to finish all your upload sessions in a single request.
 * UploadSessionStartArg.close or UploadSessionAppendArg.close needs to be true
 * for the last upload_session/start or upload_session/append_v2 call. The
 * maximum size of a file one can upload to an upload session is 2^41 - 2^22
 * (2,199,019,061,248) bytes. This route will return a job_id immediately and do
 * the async commit job in background. Use upload_session/finish_batch/check to
 * check the job status. For the same account, this route should be executed
 * serially. That means you should not start the next job before current job
 * finishes. We allow up to 1000 entries in a single request. Calls to this
 * endpoint will count as data transport calls for any Dropbox Business teams
 * with a limit on the number of data transport calls allowed per month. For
 * more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatch
 * @deprecated
 * @arg {FilesUploadSessionFinishBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchLaunch>, DropboxResponseError.<void>>}
 */
routes.filesUploadSessionFinishBatch = function (arg, options) {
  return this.request('files/upload_session/finish_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * This route helps you commit many files at once into a user's Dropbox. Use
 * upload_session/start and upload_session/append_v2 to upload file contents. We
 * recommend uploading many files in parallel to increase throughput. Once the
 * file contents have been uploaded, rather than calling upload_session/finish,
 * use this route to finish all your upload sessions in a single request.
 * UploadSessionStartArg.close or UploadSessionAppendArg.close needs to be true
 * for the last upload_session/start or upload_session/append_v2 call of each
 * upload session. The maximum size of a file one can upload to an upload
 * session is 2^41 - 2^22 (2,199,019,061,248) bytes. We allow up to 1000 entries
 * in a single request. Calls to this endpoint will count as data transport
 * calls for any Dropbox Business teams with a limit on the number of data
 * transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatchV2
 * @arg {FilesUploadSessionFinishBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchResult>, DropboxResponseError.<void>>}
 */
routes.filesUploadSessionFinishBatchV2 = function (arg, options) {
  return this.request('files/upload_session/finish_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Returns the status of an asynchronous job for upload_session/finish_batch. If
 * success, it returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.filesUploadSessionFinishBatchCheck = function (arg, options) {
  return this.request('files/upload_session/finish_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Upload sessions allow you to upload a single file in one or more requests,
 * for example where the size of the file is greater than 150 MiB. This call
 * starts a new upload session with the given data. You can then use
 * upload_session/append_v2 or upload_session/append_batch to add more data,
 * then upload_session/finish or upload_session/finish_batch_v2 to save all the
 * data to a file in Dropbox. A single request should not upload more than 150
 * MiB. The maximum size of a file one can upload to an upload session is 2^41 -
 * 2^22 (2,199,019,061,248) bytes. An upload session can be used for a maximum
 * of 7 days. Attempting to use a UploadSessionStartResult.session_id with
 * upload_session/append_v2 or other upload session routes more than 7 days
 * after its creation will return UploadSessionLookupError.not_found. Calls to
 * this endpoint will count as data transport calls for any Dropbox Business
 * teams with a limit on the number of data transport calls allowed per month.
 * For more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit. By
 * default, upload sessions require you to send content of the file in
 * sequential order via consecutive upload_session/start,
 * upload_session/append_v2, and upload_session/finish calls (or their batch
 * variants). For better performance, you can optionally set
 * UploadSessionStartArg.session_type to UploadSessionType.concurrent to start a
 * concurrent upload session. Concurrent upload sessions may upload file data in
 * concurrent upload_session/append_v2 requests, with a few caveats. After all
 * of the requests are complete, finish the session with upload_session/finish
 * as normal. You can not send data in a upload_session/start or
 * upload_session/finish call, only with upload_session/append_v2 or
 * upload_session/append_batch. Also, the length of the uploaded data in a call
 * to upload_session/append_v2 or upload_session/append_batch must be a multiple
 * of 2^22 (4,194,304) bytes, except for the final append request with
 * UploadSessionAppendArg.close or UploadSessionAppendBatchArgEntry.close set to
 * true that may contain any remaining data.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionStart
 * @arg {FilesUploadSessionStartArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionStartResult>, DropboxResponseError.<FilesUploadSessionStartError>>}
 */
routes.filesUploadSessionStart = function (arg, options) {
  return this.request('files/upload_session/start', arg, 'user', 'content', 'upload', 'files.content.write', options);
};

/**
 * Start a batch of upload sessions. See upload_session/start. Calls to this
 * endpoint will count as data transport calls for any Dropbox Business teams
 * with a limit on the number of data transport calls allowed per month. For
 * more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionStartBatch
 * @arg {FilesUploadSessionStartBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionStartBatchResult>, DropboxResponseError.<void>>}
 */
routes.filesUploadSessionStartBatch = function (arg, options) {
  return this.request('files/upload_session/start_batch', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * This route is used for refreshing the info that is found in the id_token
 * during the OIDC flow. This route doesn't require any arguments and will use
 * the scopes approved for the given access token.
 * Route attributes:
 *   scope: openid
 * @function Dropbox#openidUserinfo
 * @arg {OpenidUserInfoArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<OpenidUserInfoResult>, DropboxResponseError.<OpenidUserInfoError>>}
 */
routes.openidUserinfo = function (arg, options) {
  return this.request('openid/userinfo', arg, 'user', 'api', 'rpc', 'openid', options);
};

/**
 * Marks the given Paper doc as archived. This action can be performed or undone
 * by anyone with edit permissions to the doc. Note that this endpoint will
 * continue to work for content created by users on the older version of Paper.
 * To check which version of Paper a user is on, use /users/features/get_values.
 * If the paper_as_files feature is enabled, then the user is running the new
 * version of Paper. This endpoint will be retired in September 2020. Refer to
 * the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsArchive
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsArchive = function (arg, options) {
  return this.request('paper/docs/archive', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Creates a new Paper doc with the provided content. Note that this endpoint
 * will continue to work for content created by users on the older version of
 * Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. This endpoint will be retired
 * in September 2020. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsCreate
 * @deprecated
 * @arg {PaperPaperDocCreateArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperPaperDocCreateUpdateResult>, DropboxResponseError.<PaperPaperDocCreateError>>}
 */
routes.paperDocsCreate = function (arg, options) {
  return this.request('paper/docs/create', arg, 'user', 'api', 'upload', 'files.content.write', options);
};

/**
 * Exports and downloads Paper doc either as HTML or markdown. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#paperDocsDownload
 * @deprecated
 * @arg {PaperPaperDocExport} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperPaperDocExportResult>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsDownload = function (arg, options) {
  return this.request('paper/docs/download', arg, 'user', 'api', 'download', 'files.content.read', options);
};

/**
 * Lists the users who are explicitly invited to the Paper folder in which the
 * Paper doc is contained. For private folders all users (including owner)
 * shared on the folder are listed and for team folders all non-team users
 * shared on the folder are returned. Note that this endpoint will continue to
 * work for content created by users on the older version of Paper. To check
 * which version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsFolderUsersList
 * @deprecated
 * @arg {PaperListUsersOnFolderArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnFolderResponse>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsFolderUsersList = function (arg, options) {
  return this.request('paper/docs/folder_users/list', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from docs/folder_users/list, use this to
 * paginate through all users on the Paper folder. Note that this endpoint will
 * continue to work for content created by users on the older version of Paper.
 * To check which version of Paper a user is on, use /users/features/get_values.
 * If the paper_as_files feature is enabled, then the user is running the new
 * version of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsFolderUsersListContinue
 * @deprecated
 * @arg {PaperListUsersOnFolderContinueArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnFolderResponse>, DropboxResponseError.<PaperListUsersCursorError>>}
 */
routes.paperDocsFolderUsersListContinue = function (arg, options) {
  return this.request('paper/docs/folder_users/list/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Retrieves folder information for the given Paper doc. This includes: - folder
 * sharing policy; permissions for subfolders are set by the top-level folder. -
 * full 'filepath', i.e. the list of folders (both folderId and folderName) from
 * the root folder to the folder directly containing the Paper doc. If the Paper
 * doc is not in any folder (aka unfiled) the response will be empty. Note that
 * this endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsGetFolderInfo
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperFoldersContainingPaperDoc>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsGetFolderInfo = function (arg, options) {
  return this.request('paper/docs/get_folder_info', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Returns metadata for a Paper doc or Cloud Doc.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#paperDocsGetMetadata
 * @arg {PaperGetDocMetadataArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperPaperDocGetMetadataResult>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsGetMetadata = function (arg, options) {
  return this.request('paper/docs/get_metadata', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Return the list of all Paper docs according to the argument specifications.
 * To iterate over through the full pagination, pass the cursor to
 * docs/list/continue. Note that this endpoint will continue to work for content
 * created by users on the older version of Paper. To check which version of
 * Paper a user is on, use /users/features/get_values. If the paper_as_files
 * feature is enabled, then the user is running the new version of Paper. Refer
 * to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#paperDocsList
 * @deprecated
 * @arg {PaperListPaperDocsArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListPaperDocsResponse>, DropboxResponseError.<void>>}
 */
routes.paperDocsList = function (arg, options) {
  return this.request('paper/docs/list', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Once a cursor has been retrieved from docs/list, use this to paginate through
 * all Paper doc. Note that this endpoint will continue to work for content
 * created by users on the older version of Paper. To check which version of
 * Paper a user is on, use /users/features/get_values. If the paper_as_files
 * feature is enabled, then the user is running the new version of Paper. Refer
 * to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#paperDocsListContinue
 * @deprecated
 * @arg {PaperListPaperDocsContinueArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListPaperDocsResponse>, DropboxResponseError.<PaperListDocsCursorError>>}
 */
routes.paperDocsListContinue = function (arg, options) {
  return this.request('paper/docs/list/continue', arg, 'user', 'api', 'rpc', 'files.metadata.read', options);
};

/**
 * Permanently deletes the given Paper doc. This operation is final as the doc
 * cannot be recovered. This action can be performed only by the doc owner. Note
 * that this endpoint will continue to work for content created by users on the
 * older version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.permanent_delete
 * @function Dropbox#paperDocsPermanentlyDelete
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsPermanentlyDelete = function (arg, options) {
  return this.request('paper/docs/permanently_delete', arg, 'user', 'api', 'rpc', 'files.permanent_delete', options);
};

/**
 * Gets the default sharing policy for the given Paper doc. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsSharingPolicyGet
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperSharingPolicy>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsSharingPolicyGet = function (arg, options) {
  return this.request('paper/docs/sharing_policy/get', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Sets the default sharing policy for the given Paper doc. The default
 * 'team_sharing_policy' can be changed only by teams, omit this field for
 * personal accounts. The 'public_sharing_policy' policy can't be set to the
 * value 'disabled' because this setting can be changed only via the team admin
 * console. Note that this endpoint will continue to work for content created by
 * users on the older version of Paper. To check which version of Paper a user
 * is on, use /users/features/get_values. If the paper_as_files feature is
 * enabled, then the user is running the new version of Paper. Refer to the
 * Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsSharingPolicySet
 * @deprecated
 * @arg {PaperPaperDocSharingPolicy} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsSharingPolicySet = function (arg, options) {
  return this.request('paper/docs/sharing_policy/set', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Updates an existing Paper doc with the provided content. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. This endpoint will be retired
 * in September 2020. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsUpdate
 * @deprecated
 * @arg {PaperPaperDocUpdateArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperPaperDocCreateUpdateResult>, DropboxResponseError.<PaperPaperDocUpdateError>>}
 */
routes.paperDocsUpdate = function (arg, options) {
  return this.request('paper/docs/update', arg, 'user', 'api', 'upload', 'files.content.write', options);
};

/**
 * Allows an owner or editor to add users to a Paper doc or change their
 * permissions using their email address or Dropbox account ID. The doc owner's
 * permissions cannot be changed. Note that this endpoint will continue to work
 * for content created by users on the older version of Paper. To check which
 * version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsUsersAdd
 * @deprecated
 * @arg {PaperAddPaperDocUser} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<PaperAddPaperDocUserMemberResult>>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsUsersAdd = function (arg, options) {
  return this.request('paper/docs/users/add', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Lists all users who visited the Paper doc or users with explicit access. This
 * call excludes users who have been removed. The list is sorted by the date of
 * the visit or the share date. The list will include both users, the explicitly
 * shared ones as well as those who came in using the Paper url link. Note that
 * this endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsUsersList
 * @deprecated
 * @arg {PaperListUsersOnPaperDocArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnPaperDocResponse>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsUsersList = function (arg, options) {
  return this.request('paper/docs/users/list', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from docs/users/list, use this to paginate
 * through all users on the Paper doc. Note that this endpoint will continue to
 * work for content created by users on the older version of Paper. To check
 * which version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsUsersListContinue
 * @deprecated
 * @arg {PaperListUsersOnPaperDocContinueArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnPaperDocResponse>, DropboxResponseError.<PaperListUsersCursorError>>}
 */
routes.paperDocsUsersListContinue = function (arg, options) {
  return this.request('paper/docs/users/list/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Allows an owner or editor to remove users from a Paper doc using their email
 * address or Dropbox account ID. The doc owner cannot be removed. Note that
 * this endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsUsersRemove
 * @deprecated
 * @arg {PaperRemovePaperDocUser} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */
routes.paperDocsUsersRemove = function (arg, options) {
  return this.request('paper/docs/users/remove', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Create a new Paper folder with the provided info. Note that this endpoint
 * will continue to work for content created by users on the older version of
 * Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperFoldersCreate
 * @deprecated
 * @arg {PaperPaperFolderCreateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<PaperPaperFolderCreateResult>, DropboxResponseError.<PaperPaperFolderCreateError>>}
 */
routes.paperFoldersCreate = function (arg, options) {
  return this.request('paper/folders/create', arg, 'user', 'api', 'rpc', 'files.content.write', options);
};

/**
 * Asynchronous document-to-markdown conversion for supported file formats.
 * Supported formats: .binder, .docx, .html, .paper, .papert, .pptx, .xlsx,
 * .gsheet, .ods, .pdf. Unsupported formats return an
 * `unsupported_format_error`. Size limit: the source file must be at most 50
 * MB. Larger files are rejected.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetMarkdownAsync
 * @arg {RivieraGetMarkdownArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<void>>}
 */
routes.rivieraGetMarkdownAsync = function (arg, options) {
  return this.request('riviera/get_markdown_async', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the status or result of specified get_markdown_async task.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetMarkdownAsyncCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<RivieraGetMarkdownAsyncCheckResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.rivieraGetMarkdownAsyncCheck = function (arg, options) {
  return this.request('riviera/get_markdown_async/check', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Asynchronous file metadata extraction for supported file formats. The kind of
 * metadata returned depends on the file type: - Image (EXIF) formats: .3fr,
 * .arw, .avif, .bmp, .cr2, .cr3, .crw, .dcr, .dcs, .dng, .erf, .gif, .heic,
 * .j2c, .j2k, .jp2, .jpc, .jpeg, .jpf, .jpg, .jpg2, .jpm, .jpx, .kdc, .mef,
 * .mos, .mrw, .nef, .nrw, .orf, .pef, .png, .ppm, .r3d, .raf, .rw2, .rwl, .sr2,
 * .tga, .tif, .tiff, .wbmp, .web, .webp, .x3f. - Audio/video (media) formats:
 * .aac, .aif, .aiff, .flac, .m4a, .m4r, .mp3, .oga, .ogg, .wav, .wma, .3gp,
 * .3gpp, .3gpp2, .asf, .avi, .dv, .flv, .m2t, .m2ts, .m4v, .mkv, .mov, .mp4,
 * .mpeg, .mpg, .mts, .mxf, .oggtheora, .ogv, .rm, .ts, .vob, .webm, .wmv. - PDF
 * format: .pdf. - MS Office formats: .docx, .pptx, .xlsx. Unsupported formats
 * return an `unsupported_format_error`.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetMetadataAsync
 * @arg {RivieraGetMetadataArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<void>>}
 */
routes.rivieraGetMetadataAsync = function (arg, options) {
  return this.request('riviera/get_metadata_async', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the status or result of specified get_metadata_async task.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetMetadataAsyncCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<RivieraGetMetadataAsyncCheckResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.rivieraGetMetadataAsyncCheck = function (arg, options) {
  return this.request('riviera/get_metadata_async/check', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Asynchronous OCR (optical character recognition) text extraction for images
 * and PDFs, including scanned / non-text PDFs. Supported formats: - Image
 * formats: .bmp, .gif, .heic, .jpeg, .jpg, .png, .tif, .tiff, .webp. - PDF
 * format: .pdf. Unsupported formats return an `unsupported_format_error`. For
 * the `url` variant only Dropbox shared links are supported; external URLs
 * return `unsupported_format_error`. Text-based PDFs already carry a text
 * layer, so OCR is not run against them and the result is empty; use
 * `get_text_async` to read the embedded text layer of such a PDF. The result
 * carries the extracted words as plain text, plus the same content as hOCR with
 * per-word coordinates.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetOcrAsync
 * @arg {RivieraGetOcrArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<void>>}
 */
routes.rivieraGetOcrAsync = function (arg, options) {
  return this.request('riviera/get_ocr_async', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the status or result of specified get_ocr_async task.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetOcrAsyncCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<RivieraGetOcrAsyncCheckResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.rivieraGetOcrAsyncCheck = function (arg, options) {
  return this.request('riviera/get_ocr_async/check', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Asynchronous plain-text extraction from documents. Supported formats include:
 * - Word processing: .doc, .docx, .docm, .rtf. - Presentations: .ppt, .pptx,
 * .pptm. - Spreadsheets: .xls, .xlsx, .xlsm. - PDF: .pdf. - Dropbox document
 * types: .paper, .papert, .binder, .gdoc, .gsheet, .gslides. - Plain text /
 * subtitles: .txt, .vtt. Unsupported formats return an
 * `unsupported_format_error`. For the `url` variant only Dropbox shared links
 * are supported; external URLs return `unsupported_format_error`.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetTextAsync
 * @arg {RivieraGetTextArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<void>>}
 */
routes.rivieraGetTextAsync = function (arg, options) {
  return this.request('riviera/get_text_async', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the status or result of specified get_text_async task.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetTextAsyncCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<RivieraGetTextAsyncCheckResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.rivieraGetTextAsyncCheck = function (arg, options) {
  return this.request('riviera/get_text_async/check', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Asynchronous transcript generation for audio and video files. Supported audio
 * formats: .aac, .aif, .aiff, .flac, .m4a, .m4r, .mp3, .oga, .ogg, .wav, .wma.
 * Supported video formats: .3gp, .3gpp, .3gpp2, .asf, .avi, .dv, .flv, .m2t,
 * .m2ts, .m4v, .mkv, .mov, .mp4, .mpeg, .mpg, .mts, .mxf, .oggtheora, .ogv,
 * .rm, .ts, .vob, .webm, .wmv. Unsupported formats return an
 * `unsupported_format_error`. Size limits: the source file must be at most 10
 * GB and its audio track at most 1 hour in duration. Files exceeding these
 * limits are rejected.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetTranscriptAsync
 * @arg {RivieraGetTranscriptArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<void>>}
 */
routes.rivieraGetTranscriptAsync = function (arg, options) {
  return this.request('riviera/get_transcript_async', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Returns the status or result of specified get_transcript_async task.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#rivieraGetTranscriptAsyncCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<RivieraGetTranscriptAsyncCheckResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.rivieraGetTranscriptAsyncCheck = function (arg, options) {
  return this.request('riviera/get_transcript_async/check', arg, 'app, user', 'api', 'rpc', 'files.content.read', options);
};

/**
 * Adds specified members to a file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingAddFileMember
 * @arg {SharingAddFileMemberArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<SharingFileMemberActionResult>>, DropboxResponseError.<SharingAddFileMemberError>>}
 */
routes.sharingAddFileMember = function (arg, options) {
  return this.request('sharing/add_file_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to add another member. For the new member to get access to all the
 * functionality for this folder, you will need to call mount_folder on their
 * behalf.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingAddFolderMember
 * @arg {SharingAddFolderMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingAddFolderMemberError>>}
 */
routes.sharingAddFolderMember = function (arg, options) {
  return this.request('sharing/add_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Returns the status of an asynchronous job.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.sharingCheckJobStatus = function (arg, options) {
  return this.request('sharing/check_job_status', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Returns the status of an asynchronous job for sharing a folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckRemoveMemberJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingRemoveMemberJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.sharingCheckRemoveMemberJobStatus = function (arg, options) {
  return this.request('sharing/check_remove_member_job_status', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Returns the status of an asynchronous job for sharing a folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckShareJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingShareFolderJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.sharingCheckShareJobStatus = function (arg, options) {
  return this.request('sharing/check_share_job_status', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Create a shared link. If a shared link already exists for the given path,
 * that link is returned. Previously, it was technically possible to break a
 * shared link by moving or renaming the corresponding file or folder. In the
 * future, this will no longer be the case, so your app shouldn't rely on this
 * behavior. Instead, if your app needs to revoke a shared link, use
 * revoke_shared_link. DEPRECATED: Use create_shared_link_with_settings instead.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCreateSharedLink
 * @deprecated
 * @arg {SharingCreateSharedLinkArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingPathLinkMetadata>, DropboxResponseError.<SharingCreateSharedLinkError>>}
 */
routes.sharingCreateSharedLink = function (arg, options) {
  return this.request('sharing/create_shared_link', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Create a shared link with custom settings. If no settings are given then the
 * default visibility is RequestedVisibility.public (The resolved visibility,
 * though, may depend on other aspects such as team and shared folder settings).
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCreateSharedLinkWithSettings
 * @arg {SharingCreateSharedLinkWithSettingsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingCreateSharedLinkWithSettingsError>>}
 */
routes.sharingCreateSharedLinkWithSettings = function (arg, options) {
  return this.request('sharing/create_shared_link_with_settings', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Returns shared file metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFileMetadata
 * @arg {SharingGetFileMetadataArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMetadata>, DropboxResponseError.<SharingGetFileMetadataError>>}
 */
routes.sharingGetFileMetadata = function (arg, options) {
  return this.request('sharing/get_file_metadata', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Returns shared file metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFileMetadataBatch
 * @arg {SharingGetFileMetadataBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<SharingGetFileMetadataBatchResult>>, DropboxResponseError.<SharingSharingUserError>>}
 */
routes.sharingGetFileMetadataBatch = function (arg, options) {
  return this.request('sharing/get_file_metadata/batch', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Returns shared folder metadata by its folder ID.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFolderMetadata
 * @arg {SharingGetMetadataArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingSharedFolderAccessError>>}
 */
routes.sharingGetFolderMetadata = function (arg, options) {
  return this.request('sharing/get_folder_metadata', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Download the shared link's file from a user's Dropbox. This is a
 * download-style endpoint that returns the file content.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinkFile
 * @arg {Object} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingGetSharedLinkFileError>>}
 */
routes.sharingGetSharedLinkFile = function (arg, options) {
  return this.request('sharing/get_shared_link_file', arg, 'app, user', 'content', 'download', 'sharing.read', options);
};

/**
 * Get the shared link's metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinkMetadata
 * @arg {SharingGetSharedLinkMetadataArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingSharedLinkMetadataError>>}
 */
routes.sharingGetSharedLinkMetadata = function (arg, options) {
  return this.request('sharing/get_shared_link_metadata', arg, 'app, user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * DEPRECATED: Use list_shared_links instead. This endpoint will be retired in
 * October 2026. Returns a list of LinkMetadata objects for this user, including
 * collection links. If no path is given, returns a list of all shared links for
 * the current user, including collection links, up to a maximum of 1000 links.
 * If a non-empty path is given, returns a list of all shared links that allow
 * access to the given path. Collection links are never returned in this case.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinks
 * @deprecated
 * @arg {SharingGetSharedLinksArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingGetSharedLinksResult>, DropboxResponseError.<SharingGetSharedLinksError>>}
 */
routes.sharingGetSharedLinks = function (arg, options) {
  return this.request('sharing/get_shared_links', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Use to obtain the members who have been invited to a file, both inherited and
 * uninherited members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembers
 * @arg {SharingListFileMembersArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMembers>, DropboxResponseError.<SharingListFileMembersError>>}
 */
routes.sharingListFileMembers = function (arg, options) {
  return this.request('sharing/list_file_members', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Get members of multiple files at once. The arguments to this route are more
 * limited, and the limit on query result size per file is more strict. To
 * customize the results more, use the individual file endpoint. Inherited users
 * and groups are not included in the result, and permissions are not returned
 * for this endpoint.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembersBatch
 * @arg {SharingListFileMembersBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<SharingListFileMembersBatchResult>>, DropboxResponseError.<SharingSharingUserError>>}
 */
routes.sharingListFileMembersBatch = function (arg, options) {
  return this.request('sharing/list_file_members/batch', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from list_file_members or
 * list_file_members/batch, use this to paginate through all shared file
 * members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembersContinue
 * @arg {SharingListFileMembersContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMembers>, DropboxResponseError.<SharingListFileMembersContinueError>>}
 */
routes.sharingListFileMembersContinue = function (arg, options) {
  return this.request('sharing/list_file_members/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Returns shared folder membership by its folder ID.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolderMembers
 * @arg {SharingListFolderMembersArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMembers>, DropboxResponseError.<SharingSharedFolderAccessError>>}
 */
routes.sharingListFolderMembers = function (arg, options) {
  return this.request('sharing/list_folder_members', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from list_folder_members, use this to
 * paginate through all shared folder members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolderMembersContinue
 * @arg {SharingListFolderMembersContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMembers>, DropboxResponseError.<SharingListFolderMembersContinueError>>}
 */
routes.sharingListFolderMembersContinue = function (arg, options) {
  return this.request('sharing/list_folder_members/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Return the list of all shared folders the current user has access to.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<void>>}
 */
routes.sharingListFolders = function (arg, options) {
  return this.request('sharing/list_folders', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from list_folders, use this to paginate
 * through all shared folders. The cursor must come from a previous call to
 * list_folders or list_folders/continue.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<SharingListFoldersContinueError>>}
 */
routes.sharingListFoldersContinue = function (arg, options) {
  return this.request('sharing/list_folders/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Return the list of all shared folders the current user can mount or unmount.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListMountableFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<void>>}
 */
routes.sharingListMountableFolders = function (arg, options) {
  return this.request('sharing/list_mountable_folders', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Once a cursor has been retrieved from list_mountable_folders, use this to
 * paginate through all mountable shared folders. The cursor must come from a
 * previous call to list_mountable_folders or list_mountable_folders/continue.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListMountableFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<SharingListFoldersContinueError>>}
 */
routes.sharingListMountableFoldersContinue = function (arg, options) {
  return this.request('sharing/list_mountable_folders/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Returns a list of all files shared with current user.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListReceivedFiles
 * @arg {SharingListFilesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFilesResult>, DropboxResponseError.<SharingSharingUserError>>}
 */
routes.sharingListReceivedFiles = function (arg, options) {
  return this.request('sharing/list_received_files', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Get more results with a cursor from list_received_files.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListReceivedFilesContinue
 * @arg {SharingListFilesContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListFilesResult>, DropboxResponseError.<SharingListFilesContinueError>>}
 */
routes.sharingListReceivedFilesContinue = function (arg, options) {
  return this.request('sharing/list_received_files/continue', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * List shared links of this user. If no path is given, returns a list of all
 * shared links for the current user. For members of business teams using team
 * space and member folders, returns all shared links in the team member's home
 * folder unless the team space ID is specified in the request header. If a
 * non-empty path is given, returns a list of all shared links that allow access
 * to the given path - direct links to the given path and links to parent
 * folders of the given path. Links to parent folders can be suppressed by
 * setting direct_only to true.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListSharedLinks
 * @arg {SharingListSharedLinksArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingListSharedLinksResult>, DropboxResponseError.<SharingListSharedLinksError>>}
 */
routes.sharingListSharedLinks = function (arg, options) {
  return this.request('sharing/list_shared_links', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Modify the shared link's settings. If the requested visibility conflict with
 * the shared links policy of the team or the shared folder (in case the linked
 * file is part of a shared folder) then the LinkPermissions.resolved_visibility
 * of the returned SharedLinkMetadata will reflect the actual visibility of the
 * shared link and the LinkPermissions.requested_visibility will reflect the
 * requested visibility.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingModifySharedLinkSettings
 * @arg {SharingModifySharedLinkSettingsArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingModifySharedLinkSettingsError>>}
 */
routes.sharingModifySharedLinkSettings = function (arg, options) {
  return this.request('sharing/modify_shared_link_settings', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * The current user mounts the designated folder. Mount a shared folder for a
 * user after they have been added as a member. Once mounted, the shared folder
 * will appear in their Dropbox.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingMountFolder
 * @arg {SharingMountFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingMountFolderError>>}
 */
routes.sharingMountFolder = function (arg, options) {
  return this.request('sharing/mount_folder', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Removes all self-removable access from a file or folder for the current user.
 * Best-effort and idempotent: attempts to drop link-visitor associations and
 * explicit ACL membership.
 * Route attributes:
 *   scope: private:sharing.write
 * @function Dropbox#sharingRelinquishAccess
 * @arg {SharingRelinquishAccessArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingRelinquishAccessResult>, DropboxResponseError.<SharingRelinquishAccessError>>}
 */
routes.sharingRelinquishAccess = function (arg, options) {
  return this.request('sharing/relinquish_access', arg, 'user', 'api', 'rpc', 'private:sharing.write', options);
};

/**
 * The current user relinquishes their membership in the designated file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRelinquishFileMembership
 * @arg {SharingRelinquishFileMembershipArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingRelinquishFileMembershipError>>}
 */
routes.sharingRelinquishFileMembership = function (arg, options) {
  return this.request('sharing/relinquish_file_membership', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * The current user relinquishes their membership in the designated shared
 * folder and will no longer have access to the folder.  A folder owner cannot
 * relinquish membership in their own folder. This will run synchronously if
 * leave_a_copy is false, and asynchronously if leave_a_copy is true.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRelinquishFolderMembership
 * @arg {SharingRelinquishFolderMembershipArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<SharingRelinquishFolderMembershipError>>}
 */
routes.sharingRelinquishFolderMembership = function (arg, options) {
  return this.request('sharing/relinquish_folder_membership', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Identical to remove_file_member_2 but with less information returned.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFileMember
 * @deprecated
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingFileMemberActionIndividualResult>, DropboxResponseError.<SharingRemoveFileMemberError>>}
 */
routes.sharingRemoveFileMember = function (arg, options) {
  return this.request('sharing/remove_file_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Removes a specified member from the file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFileMember2
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingFileMemberRemoveActionResult>, DropboxResponseError.<SharingRemoveFileMemberError>>}
 */
routes.sharingRemoveFileMember2 = function (arg, options) {
  return this.request('sharing/remove_file_member_2', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to remove another member.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFolderMember
 * @arg {SharingRemoveFolderMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<SharingRemoveFolderMemberError>>}
 */
routes.sharingRemoveFolderMember = function (arg, options) {
  return this.request('sharing/remove_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Revoke a shared link. Note that even after revoking a shared link to a file,
 * the file may be accessible if there are shared links leading to any of the
 * file parent folders. To list all shared links that enable access to a
 * specific file, you can use the list_shared_links with the file as the
 * ListSharedLinksArg.path argument.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRevokeSharedLink
 * @arg {SharingRevokeSharedLinkArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingRevokeSharedLinkError>>}
 */
routes.sharingRevokeSharedLink = function (arg, options) {
  return this.request('sharing/revoke_shared_link', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Change the inheritance policy of an existing Shared Folder. Only permitted
 * for shared folders in a shared team root. If a ShareFolderLaunch.async_job_id
 * is returned, you'll need to call check_share_job_status until the action
 * completes to get the metadata for the folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingSetAccessInheritance
 * @arg {SharingSetAccessInheritanceArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingShareFolderLaunch>, DropboxResponseError.<SharingSetAccessInheritanceError>>}
 */
routes.sharingSetAccessInheritance = function (arg, options) {
  return this.request('sharing/set_access_inheritance', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Share a folder with collaborators. Most sharing will be completed
 * synchronously. Large folders will be completed asynchronously. To make
 * testing the async case repeatable, set `ShareFolderArg.force_async`. If a
 * ShareFolderLaunch.async_job_id is returned, you'll need to call
 * check_share_job_status until the action completes to get the metadata for the
 * folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingShareFolder
 * @arg {SharingShareFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingShareFolderLaunch>, DropboxResponseError.<SharingShareFolderError>>}
 */
routes.sharingShareFolder = function (arg, options) {
  return this.request('sharing/share_folder', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Transfer ownership of a shared folder to a member of the shared folder. User
 * must have AccessLevel.owner access to the shared folder to perform a
 * transfer.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingTransferFolder
 * @arg {SharingTransferFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingTransferFolderError>>}
 */
routes.sharingTransferFolder = function (arg, options) {
  return this.request('sharing/transfer_folder', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * The current user unmounts the designated folder. They can re-mount the folder
 * at a later time using mount_folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnmountFolder
 * @arg {SharingUnmountFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingUnmountFolderError>>}
 */
routes.sharingUnmountFolder = function (arg, options) {
  return this.request('sharing/unmount_folder', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Remove all members from this file. Does not remove inherited members.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnshareFile
 * @arg {SharingUnshareFileArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingUnshareFileError>>}
 */
routes.sharingUnshareFile = function (arg, options) {
  return this.request('sharing/unshare_file', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Allows a shared folder owner to unshare the folder. Unshare will not work in
 * following cases: The shared folder contains shared folders OR the shared
 * folder is inside another shared folder. You'll need to call check_job_status
 * to determine if the action has completed successfully.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnshareFolder
 * @arg {SharingUnshareFolderArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<SharingUnshareFolderError>>}
 */
routes.sharingUnshareFolder = function (arg, options) {
  return this.request('sharing/unshare_folder', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Changes a member's access on a shared file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFileMember
 * @arg {SharingUpdateFileMemberArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingMemberAccessLevelResult>, DropboxResponseError.<SharingFileMemberActionError>>}
 */
routes.sharingUpdateFileMember = function (arg, options) {
  return this.request('sharing/update_file_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Update the viewer info policy of a file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFilePolicy
 * @arg {SharingUpdateFilePolicyArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMetadata>, DropboxResponseError.<SharingUpdateFilePolicyError>>}
 */
routes.sharingUpdateFilePolicy = function (arg, options) {
  return this.request('sharing/update_file_policy', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Allows an owner or editor of a shared folder to update another member's
 * permissions.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFolderMember
 * @arg {SharingUpdateFolderMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingMemberAccessLevelResult>, DropboxResponseError.<SharingUpdateFolderMemberError>>}
 */
routes.sharingUpdateFolderMember = function (arg, options) {
  return this.request('sharing/update_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * Update the sharing policies for a shared folder. User must have
 * AccessLevel.owner access to the shared folder to update its policies.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFolderPolicy
 * @arg {SharingUpdateFolderPolicyArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingUpdateFolderPolicyError>>}
 */
routes.sharingUpdateFolderPolicy = function (arg, options) {
  return this.request('sharing/update_folder_policy', arg, 'user', 'api', 'rpc', 'sharing.write', options);
};

/**
 * List all device sessions of a team's member.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListMemberDevices
 * @arg {TeamListMemberDevicesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListMemberDevicesResult>, DropboxResponseError.<TeamListMemberDevicesError>>}
 */
routes.teamDevicesListMemberDevices = function (arg, options) {
  return this.request('team/devices/list_member_devices', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * List all device sessions of a team. Permission : Team member file access.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListMembersDevices
 * @arg {TeamListMembersDevicesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListMembersDevicesResult>, DropboxResponseError.<TeamListMembersDevicesError>>}
 */
routes.teamDevicesListMembersDevices = function (arg, options) {
  return this.request('team/devices/list_members_devices', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * List all device sessions of a team. Permission : Team member file access.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListTeamDevices
 * @deprecated
 * @arg {TeamListTeamDevicesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListTeamDevicesResult>, DropboxResponseError.<TeamListTeamDevicesError>>}
 */
routes.teamDevicesListTeamDevices = function (arg, options) {
  return this.request('team/devices/list_team_devices', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * Revoke a device session of a team's member.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamDevicesRevokeDeviceSession
 * @arg {TeamRevokeDeviceSessionArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamRevokeDeviceSessionError>>}
 */
routes.teamDevicesRevokeDeviceSession = function (arg, options) {
  return this.request('team/devices/revoke_device_session', arg, 'team', 'api', 'rpc', 'sessions.modify', options);
};

/**
 * Revoke a list of device sessions of team members.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamDevicesRevokeDeviceSessionBatch
 * @arg {TeamRevokeDeviceSessionBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamRevokeDeviceSessionBatchResult>, DropboxResponseError.<TeamRevokeDeviceSessionBatchError>>}
 */
routes.teamDevicesRevokeDeviceSessionBatch = function (arg, options) {
  return this.request('team/devices/revoke_device_session_batch', arg, 'team', 'api', 'rpc', 'sessions.modify', options);
};

/**
 * Get the values for one or more features. This route allows you to check your
 * account's capability for what feature you can access or what value you have
 * for certain features. Permission : Team information.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamFeaturesGetValues
 * @arg {TeamFeaturesGetValuesBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamFeaturesGetValuesBatchResult>, DropboxResponseError.<TeamFeaturesGetValuesBatchError>>}
 */
routes.teamFeaturesGetValues = function (arg, options) {
  return this.request('team/features/get_values', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Retrieves information about a team.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamGetInfo
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamGetInfoResult>, DropboxResponseError.<void>>}
 */
routes.teamGetInfo = function (options) {
  return this.request('team/get_info', null, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Creates a new, empty group, with a requested name. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsCreate
 * @arg {TeamGroupCreateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupFullInfo>, DropboxResponseError.<TeamGroupCreateError>>}
 */
routes.teamGroupsCreate = function (arg, options) {
  return this.request('team/groups/create', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Deletes a group. The group is deleted immediately. However the revoking of
 * group-owned resources may take additional time. Use the groups/job_status/get
 * to determine whether this process has completed. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsDelete
 * @arg {TeamGroupSelector} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamGroupDeleteError>>}
 */
routes.teamGroupsDelete = function (arg, options) {
  return this.request('team/groups/delete', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Retrieves information about one or more groups. Note that the optional field
 * GroupFullInfo.members is not returned for system-managed groups. Permission :
 * Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsGetInfo
 * @arg {TeamGroupsSelector} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamGroupsGetInfoError>>}
 */
routes.teamGroupsGetInfo = function (arg, options) {
  return this.request('team/groups/get_info', arg, 'team', 'api', 'rpc', 'groups.read', options);
};

/**
 * Once an async_job_id is returned from groups/delete, groups/members/add , or
 * groups/members/remove use this method to poll the status of granting/revoking
 * group members' access to group-owned resources. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<TeamGroupsPollError>>}
 */
routes.teamGroupsJobStatusGet = function (arg, options) {
  return this.request('team/groups/job_status/get', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Lists groups on a team. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsList
 * @arg {TeamGroupsListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupsListResult>, DropboxResponseError.<void>>}
 */
routes.teamGroupsList = function (arg, options) {
  return this.request('team/groups/list', arg, 'team', 'api', 'rpc', 'groups.read', options);
};

/**
 * Once a cursor has been retrieved from groups/list, use this to paginate
 * through all groups. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsListContinue
 * @arg {TeamGroupsListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupsListResult>, DropboxResponseError.<TeamGroupsListContinueError>>}
 */
routes.teamGroupsListContinue = function (arg, options) {
  return this.request('team/groups/list/continue', arg, 'team', 'api', 'rpc', 'groups.read', options);
};

/**
 * Adds members to a group. The members are added immediately. However the
 * granting of group-owned resources may take additional time. Use the
 * groups/job_status/get to determine whether this process has completed.
 * Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersAdd
 * @arg {TeamGroupMembersAddArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupMembersChangeResult>, DropboxResponseError.<TeamGroupMembersAddError>>}
 */
routes.teamGroupsMembersAdd = function (arg, options) {
  return this.request('team/groups/members/add', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Lists members of a group. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsMembersList
 * @arg {TeamGroupsMembersListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupsMembersListResult>, DropboxResponseError.<TeamGroupSelectorError>>}
 */
routes.teamGroupsMembersList = function (arg, options) {
  return this.request('team/groups/members/list', arg, 'team', 'api', 'rpc', 'groups.read', options);
};

/**
 * Once a cursor has been retrieved from groups/members/list, use this to
 * paginate through all members of the group. Permission : Team information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsMembersListContinue
 * @arg {TeamGroupsMembersListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupsMembersListResult>, DropboxResponseError.<TeamGroupsMembersListContinueError>>}
 */
routes.teamGroupsMembersListContinue = function (arg, options) {
  return this.request('team/groups/members/list/continue', arg, 'team', 'api', 'rpc', 'groups.read', options);
};

/**
 * Removes members from a group. The members are removed immediately. However
 * the revoking of group-owned resources may take additional time. Use the
 * groups/job_status/get to determine whether this process has completed. This
 * method permits removing the only owner of a group, even in cases where this
 * is not possible via the web client. Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersRemove
 * @arg {TeamGroupMembersRemoveArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupMembersChangeResult>, DropboxResponseError.<TeamGroupMembersRemoveError>>}
 */
routes.teamGroupsMembersRemove = function (arg, options) {
  return this.request('team/groups/members/remove', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Sets a member's access type in a group. Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersSetAccessType
 * @arg {TeamGroupMembersSetAccessTypeArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamGroupMemberSetAccessTypeError>>}
 */
routes.teamGroupsMembersSetAccessType = function (arg, options) {
  return this.request('team/groups/members/set_access_type', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Updates a group's name and/or external ID. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsUpdate
 * @arg {TeamGroupUpdateArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGroupFullInfo>, DropboxResponseError.<TeamGroupUpdateError>>}
 */
routes.teamGroupsUpdate = function (arg, options) {
  return this.request('team/groups/update', arg, 'team', 'api', 'rpc', 'groups.write', options);
};

/**
 * Creates new legal hold policy. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsCreatePolicy
 * @arg {TeamLegalHoldsPolicyCreateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsPolicyCreateError>>}
 */
routes.teamLegalHoldsCreatePolicy = function (arg, options) {
  return this.request('team/legal_holds/create_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * Gets a legal hold by Id. Note: Legal Holds is a paid add-on. Not all teams
 * have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsGetPolicy
 * @arg {TeamLegalHoldsGetPolicyArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsGetPolicyError>>}
 */
routes.teamLegalHoldsGetPolicy = function (arg, options) {
  return this.request('team/legal_holds/get_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * List the file metadata that's under the hold. Note: Legal Holds is a paid
 * add-on. Not all teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListHeldRevisions
 * @arg {TeamLegalHoldsListHeldRevisionsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListHeldRevisionResult>, DropboxResponseError.<TeamLegalHoldsListHeldRevisionsError>>}
 */
routes.teamLegalHoldsListHeldRevisions = function (arg, options) {
  return this.request('team/legal_holds/list_held_revisions', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * Continue listing the file metadata that's under the hold. Note: Legal Holds
 * is a paid add-on. Not all teams have the feature. Permission : Team member
 * file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListHeldRevisionsContinue
 * @arg {TeamLegalHoldsListHeldRevisionsContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListHeldRevisionResult>, DropboxResponseError.<TeamLegalHoldsListHeldRevisionsError>>}
 */
routes.teamLegalHoldsListHeldRevisionsContinue = function (arg, options) {
  return this.request('team/legal_holds/list_held_revisions_continue', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * Lists legal holds on a team. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListPolicies
 * @arg {TeamLegalHoldsListPoliciesArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListPoliciesResult>, DropboxResponseError.<TeamLegalHoldsListPoliciesError>>}
 */
routes.teamLegalHoldsListPolicies = function (arg, options) {
  return this.request('team/legal_holds/list_policies', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * Releases a legal hold by Id. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsReleasePolicy
 * @arg {TeamLegalHoldsPolicyReleaseArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamLegalHoldsPolicyReleaseError>>}
 */
routes.teamLegalHoldsReleasePolicy = function (arg, options) {
  return this.request('team/legal_holds/release_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * Updates a legal hold. Note: Legal Holds is a paid add-on. Not all teams have
 * the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsUpdatePolicy
 * @arg {TeamLegalHoldsPolicyUpdateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsPolicyUpdateError>>}
 */
routes.teamLegalHoldsUpdatePolicy = function (arg, options) {
  return this.request('team/legal_holds/update_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write', options);
};

/**
 * List all linked applications of the team member. Note, this endpoint does not
 * list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListMemberLinkedApps
 * @arg {TeamListMemberAppsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListMemberAppsResult>, DropboxResponseError.<TeamListMemberAppsError>>}
 */
routes.teamLinkedAppsListMemberLinkedApps = function (arg, options) {
  return this.request('team/linked_apps/list_member_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * List all applications linked to the team members' accounts. Note, this
 * endpoint does not list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListMembersLinkedApps
 * @arg {TeamListMembersAppsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListMembersAppsResult>, DropboxResponseError.<TeamListMembersAppsError>>}
 */
routes.teamLinkedAppsListMembersLinkedApps = function (arg, options) {
  return this.request('team/linked_apps/list_members_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * List all applications linked to the team members' accounts. Note, this
 * endpoint doesn't list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListTeamLinkedApps
 * @deprecated
 * @arg {TeamListTeamAppsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamListTeamAppsResult>, DropboxResponseError.<TeamListTeamAppsError>>}
 */
routes.teamLinkedAppsListTeamLinkedApps = function (arg, options) {
  return this.request('team/linked_apps/list_team_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list', options);
};

/**
 * Revoke a linked application of the team member.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamLinkedAppsRevokeLinkedApp
 * @arg {TeamRevokeLinkedApiAppArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamRevokeLinkedAppError>>}
 */
routes.teamLinkedAppsRevokeLinkedApp = function (arg, options) {
  return this.request('team/linked_apps/revoke_linked_app', arg, 'team', 'api', 'rpc', 'sessions.modify', options);
};

/**
 * Revoke a list of linked applications of the team members.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamLinkedAppsRevokeLinkedAppBatch
 * @arg {TeamRevokeLinkedApiAppBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamRevokeLinkedAppBatchResult>, DropboxResponseError.<TeamRevokeLinkedAppBatchError>>}
 */
routes.teamLinkedAppsRevokeLinkedAppBatch = function (arg, options) {
  return this.request('team/linked_apps/revoke_linked_app_batch', arg, 'team', 'api', 'rpc', 'sessions.modify', options);
};

/**
 * Add users to member space limits excluded users list.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersAdd
 * @arg {TeamExcludedUsersUpdateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersUpdateResult>, DropboxResponseError.<TeamExcludedUsersUpdateError>>}
 */
routes.teamMemberSpaceLimitsExcludedUsersAdd = function (arg, options) {
  return this.request('team/member_space_limits/excluded_users/add', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * List member space limits excluded users.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersList
 * @arg {TeamExcludedUsersListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersListResult>, DropboxResponseError.<TeamExcludedUsersListError>>}
 */
routes.teamMemberSpaceLimitsExcludedUsersList = function (arg, options) {
  return this.request('team/member_space_limits/excluded_users/list', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Continue listing member space limits excluded users.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersListContinue
 * @arg {TeamExcludedUsersListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersListResult>, DropboxResponseError.<TeamExcludedUsersListContinueError>>}
 */
routes.teamMemberSpaceLimitsExcludedUsersListContinue = function (arg, options) {
  return this.request('team/member_space_limits/excluded_users/list/continue', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Remove users from member space limits excluded users list.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersRemove
 * @arg {TeamExcludedUsersUpdateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersUpdateResult>, DropboxResponseError.<TeamExcludedUsersUpdateError>>}
 */
routes.teamMemberSpaceLimitsExcludedUsersRemove = function (arg, options) {
  return this.request('team/member_space_limits/excluded_users/remove', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Get users custom quota. A maximum of 1000 members can be specified in a
 * single call. Note: to apply a custom space limit, a team admin needs to set a
 * member space limit for the team first. (the team admin can check the settings
 * here: https://www.dropbox.com/team/admin/settings/space).
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsGetCustomQuota
 * @arg {TeamCustomQuotaUsersArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<TeamCustomQuotaResult>>, DropboxResponseError.<TeamCustomQuotaError>>}
 */
routes.teamMemberSpaceLimitsGetCustomQuota = function (arg, options) {
  return this.request('team/member_space_limits/get_custom_quota', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Remove users custom quota. A maximum of 1000 members can be specified in a
 * single call. Note: to apply a custom space limit, a team admin needs to set a
 * member space limit for the team first. (the team admin can check the settings
 * here: https://www.dropbox.com/team/admin/settings/space).
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsRemoveCustomQuota
 * @arg {TeamCustomQuotaUsersArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<TeamRemoveCustomQuotaResult>>, DropboxResponseError.<TeamCustomQuotaError>>}
 */
routes.teamMemberSpaceLimitsRemoveCustomQuota = function (arg, options) {
  return this.request('team/member_space_limits/remove_custom_quota', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Set users custom quota. Custom quota has to be at least 2GB. A maximum of
 * 1000 members can be specified in a single call. Note: to apply a custom space
 * limit, a team admin needs to set a member space limit for the team first.
 * (the team admin can check the settings here:
 * https://www.dropbox.com/team/admin/settings/space).
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsSetCustomQuota
 * @arg {TeamSetCustomQuotaArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<TeamCustomQuotaResult>>, DropboxResponseError.<TeamSetCustomQuotaError>>}
 */
routes.teamMemberSpaceLimitsSetCustomQuota = function (arg, options) {
  return this.request('team/member_space_limits/set_custom_quota', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Adds members to a team. Permission : Team member management A maximum of 20
 * members can be specified in a single call. If no Dropbox account exists with
 * the email address specified, a new Dropbox account will be created with the
 * given email address, and that account will be invited to the team. If a
 * personal Dropbox account exists with the email address specified in the call,
 * this call will create a placeholder Dropbox account for the user on the team
 * and send an email inviting the user to migrate their existing personal
 * account onto the team. Team member management apps are required to set an
 * initial given_name and surname for a user to use in the team invitation and
 * for 'Perform as team member' actions taken on the user before they become
 * 'active'.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAdd
 * @arg {TeamMembersAddArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersAddLaunch>, DropboxResponseError.<void>>}
 */
routes.teamMembersAdd = function (arg, options) {
  return this.request('team/members/add', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Adds members to a team. Permission : Team member management A maximum of 20
 * members can be specified in a single call. If no Dropbox account exists with
 * the email address specified, a new Dropbox account will be created with the
 * given email address, and that account will be invited to the team. If a
 * personal Dropbox account exists with the email address specified in the call,
 * this call will create a placeholder Dropbox account for the user on the team
 * and send an email inviting the user to migrate their existing personal
 * account onto the team.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddV2
 * @arg {TeamMembersAddV2Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersAddLaunchV2Result>, DropboxResponseError.<void>>}
 */
routes.teamMembersAddV2 = function (arg, options) {
  return this.request('team/members/add_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Once an async_job_id is returned from members/add , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersAddJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamMembersAddJobStatusGet = function (arg, options) {
  return this.request('team/members/add/job_status/get', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Once an async_job_id is returned from members/add_v2 , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddJobStatusGetV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersAddJobStatusV2Result>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamMembersAddJobStatusGetV2 = function (arg, options) {
  return this.request('team/members/add/job_status/get_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Launch a bulk suspend job. The server enforces a maximum of 500 members.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersBulkSuspend
 * @arg {TeamBulkSuspendArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<TeamBulkSuspendError>>}
 */
routes.teamMembersBulkSuspend = function (arg, options) {
  return this.request('team/members/bulk_suspend', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Poll a previously launched bulk suspend job.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersBulkSuspendJobStatusCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamBulkSuspendJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamMembersBulkSuspendJobStatusCheck = function (arg, options) {
  return this.request('team/members/bulk_suspend/job_status/check', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Permanently delete the files of a user who has been removed from the team.
 * After permanent deletion, those files will not be available to be transferred
 * to another team member. Permission : Team member management Exactly one of
 * team_member_id, email, or external_id must be provided to identify the user
 * account.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersDeleteFormerMemberFiles
 * @arg {TeamMembersFormerMemberArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersDeleteFormerMemberFilesError>>}
 */
routes.teamMembersDeleteFormerMemberFiles = function (arg, options) {
  return this.request('team/members/delete_former_member_files', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Deletes a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersDeleteProfilePhoto
 * @arg {TeamMembersDeleteProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersDeleteProfilePhotoError>>}
 */
routes.teamMembersDeleteProfilePhoto = function (arg, options) {
  return this.request('team/members/delete_profile_photo', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Deletes a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersDeleteProfilePhotoV2
 * @arg {TeamMembersDeleteProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersDeleteProfilePhotoError>>}
 */
routes.teamMembersDeleteProfilePhotoV2 = function (arg, options) {
  return this.request('team/members/delete_profile_photo_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Get available TeamMemberRoles for the connected team. To be used with
 * members/set_admin_permissions_v2. Permission : Team member management.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetAvailableTeamMemberRoles
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersGetAvailableTeamMemberRolesResult>, DropboxResponseError.<void>>}
 */
routes.teamMembersGetAvailableTeamMemberRoles = function (options) {
  return this.request('team/members/get_available_team_member_roles', null, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Returns information about multiple team members. Permission : Team
 * information This endpoint will return MembersGetInfoItem.id_not_found, for
 * IDs (or emails) that cannot be matched to a valid team member.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetInfo
 * @arg {TeamMembersGetInfoArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamMembersGetInfoError>>}
 */
routes.teamMembersGetInfo = function (arg, options) {
  return this.request('team/members/get_info', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Returns information about multiple team members. Permission : Team
 * information This endpoint will return MembersGetInfoItem.id_not_found, for
 * IDs (or emails) that cannot be matched to a valid team member.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetInfoV2
 * @arg {TeamMembersGetInfoV2Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersGetInfoV2Result>, DropboxResponseError.<TeamMembersGetInfoError>>}
 */
routes.teamMembersGetInfoV2 = function (arg, options) {
  return this.request('team/members/get_info_v2', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Lists members of a team. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersList
 * @arg {TeamMembersListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersListResult>, DropboxResponseError.<TeamMembersListError>>}
 */
routes.teamMembersList = function (arg, options) {
  return this.request('team/members/list', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Lists members of a team. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListV2
 * @arg {TeamMembersListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersListV2Result>, DropboxResponseError.<TeamMembersListError>>}
 */
routes.teamMembersListV2 = function (arg, options) {
  return this.request('team/members/list_v2', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Once a cursor has been retrieved from members/list, use this to paginate
 * through all team members. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListContinue
 * @arg {TeamMembersListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersListResult>, DropboxResponseError.<TeamMembersListContinueError>>}
 */
routes.teamMembersListContinue = function (arg, options) {
  return this.request('team/members/list/continue', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Once a cursor has been retrieved from members/list_v2, use this to paginate
 * through all team members. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListContinueV2
 * @arg {TeamMembersListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersListV2Result>, DropboxResponseError.<TeamMembersListContinueError>>}
 */
routes.teamMembersListContinueV2 = function (arg, options) {
  return this.request('team/members/list/continue_v2', arg, 'team', 'api', 'rpc', 'members.read', options);
};

/**
 * Moves removed member's files to a different member. This endpoint initiates
 * an asynchronous job. To obtain the final result of the job, the client should
 * periodically poll members/move_former_member_files/job_status/check.
 * Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersMoveFormerMemberFiles
 * @arg {TeamMembersDataTransferArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamMembersTransferFormerMembersFilesError>>}
 */
routes.teamMembersMoveFormerMemberFiles = function (arg, options) {
  return this.request('team/members/move_former_member_files', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Once an async_job_id is returned from members/move_former_member_files , use
 * this to poll the status of the asynchronous request. Permission : Team member
 * management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersMoveFormerMemberFilesJobStatusCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamMembersMoveFormerMemberFilesJobStatusCheck = function (arg, options) {
  return this.request('team/members/move_former_member_files/job_status/check', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Recover a deleted member. Permission : Team member management Exactly one of
 * team_member_id, email, or external_id must be provided to identify the user
 * account.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRecover
 * @arg {TeamMembersRecoverArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersRecoverError>>}
 */
routes.teamMembersRecover = function (arg, options) {
  return this.request('team/members/recover', arg, 'team', 'api', 'rpc', 'members.delete', options);
};

/**
 * Removes a member from a team. Permission : Team member management Exactly one
 * of team_member_id, email, or external_id must be provided to identify the
 * user account. Accounts can be recovered via members/recover for a 7 day
 * period or until the account has been permanently deleted or transferred to
 * another account (whichever comes first). Calling members/add while a user is
 * still recoverable on your team will return with
 * MemberAddResult.user_already_on_team. Accounts can have their files
 * transferred via the admin console for a limited time, based on the version
 * history length associated with the team (180 days for most teams). Accounts
 * can have their stacks transferred through the admin console. This only
 * transfers stacks that they have created. This endpoint may initiate an
 * asynchronous job. To obtain the final result of the job, the client should
 * periodically poll members/remove/job_status/get.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRemove
 * @arg {TeamMembersRemoveArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamMembersRemoveError>>}
 */
routes.teamMembersRemove = function (arg, options) {
  return this.request('team/members/remove', arg, 'team', 'api', 'rpc', 'members.delete', options);
};

/**
 * Once an async_job_id is returned from members/remove , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRemoveJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamMembersRemoveJobStatusGet = function (arg, options) {
  return this.request('team/members/remove/job_status/get', arg, 'team', 'api', 'rpc', 'members.delete', options);
};

/**
 * Add secondary emails to users. Permission : Team member management. Emails
 * that are on verified domains will be verified automatically. For each email
 * address not on a verified domain a verification email will be sent.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsAdd
 * @arg {TeamAddSecondaryEmailsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamAddSecondaryEmailsResult>, DropboxResponseError.<TeamAddSecondaryEmailsError>>}
 */
routes.teamMembersSecondaryEmailsAdd = function (arg, options) {
  return this.request('team/members/secondary_emails/add', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Delete secondary emails from users Permission : Team member management. Users
 * will be notified of deletions of verified secondary emails at both the
 * secondary email and their primary email.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsDelete
 * @arg {TeamDeleteSecondaryEmailsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamDeleteSecondaryEmailsResult>, DropboxResponseError.<void>>}
 */
routes.teamMembersSecondaryEmailsDelete = function (arg, options) {
  return this.request('team/members/secondary_emails/delete', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Resend secondary email verification emails. Permission : Team member
 * management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsResendVerificationEmails
 * @arg {TeamResendVerificationEmailArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamResendVerificationEmailResult>, DropboxResponseError.<void>>}
 */
routes.teamMembersSecondaryEmailsResendVerificationEmails = function (arg, options) {
  return this.request('team/members/secondary_emails/resend_verification_emails', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Sends welcome email to pending team member. Permission : Team member
 * management Exactly one of team_member_id, email, or external_id must be
 * provided to identify the user account. No-op if team member is not pending.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSendWelcomeEmail
 * @arg {TeamUserSelectorArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersSendWelcomeError>>}
 */
routes.teamMembersSendWelcomeEmail = function (arg, options) {
  return this.request('team/members/send_welcome_email', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's permissions. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetAdminPermissions
 * @arg {TeamMembersSetPermissionsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersSetPermissionsResult>, DropboxResponseError.<TeamMembersSetPermissionsError>>}
 */
routes.teamMembersSetAdminPermissions = function (arg, options) {
  return this.request('team/members/set_admin_permissions', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's permissions. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetAdminPermissionsV2
 * @arg {TeamMembersSetPermissions2Arg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamMembersSetPermissions2Result>, DropboxResponseError.<TeamMembersSetPermissions2Error>>}
 */
routes.teamMembersSetAdminPermissionsV2 = function (arg, options) {
  return this.request('team/members/set_admin_permissions_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's profile. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfile
 * @arg {TeamMembersSetProfileArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersSetProfileError>>}
 */
routes.teamMembersSetProfile = function (arg, options) {
  return this.request('team/members/set_profile', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's profile. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfileV2
 * @arg {TeamMembersSetProfileArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersSetProfileError>>}
 */
routes.teamMembersSetProfileV2 = function (arg, options) {
  return this.request('team/members/set_profile_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfilePhoto
 * @arg {TeamMembersSetProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersSetProfilePhotoError>>}
 */
routes.teamMembersSetProfilePhoto = function (arg, options) {
  return this.request('team/members/set_profile_photo', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Updates a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfilePhotoV2
 * @arg {TeamMembersSetProfilePhotoArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersSetProfilePhotoError>>}
 */
routes.teamMembersSetProfilePhotoV2 = function (arg, options) {
  return this.request('team/members/set_profile_photo_v2', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Suspend a member from a team. Permission : Team member management Exactly one
 * of team_member_id, email, or external_id must be provided to identify the
 * user account.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSuspend
 * @arg {TeamMembersDeactivateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersSuspendError>>}
 */
routes.teamMembersSuspend = function (arg, options) {
  return this.request('team/members/suspend', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Unsuspend a member from a team. Permission : Team member management Exactly
 * one of team_member_id, email, or external_id must be provided to identify the
 * user account.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersUnsuspend
 * @arg {TeamMembersUnsuspendArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersUnsuspendError>>}
 */
routes.teamMembersUnsuspend = function (arg, options) {
  return this.request('team/members/unsuspend', arg, 'team', 'api', 'rpc', 'members.write', options);
};

/**
 * Returns a list of all team-accessible namespaces. This list includes team
 * folders, shared folders containing team members, team members' home
 * namespaces, and team members' app folders. Home namespaces and app folders
 * are always owned by this team or members of the team, but shared folders may
 * be owned by other users or other teams. Duplicates may occur in the list.
 * Route attributes:
 *   scope: team_data.member
 * @function Dropbox#teamNamespacesList
 * @arg {TeamTeamNamespacesListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamNamespacesListResult>, DropboxResponseError.<TeamTeamNamespacesListError>>}
 */
routes.teamNamespacesList = function (arg, options) {
  return this.request('team/namespaces/list', arg, 'team', 'api', 'rpc', 'team_data.member', options);
};

/**
 * Once a cursor has been retrieved from namespaces/list, use this to paginate
 * through all team-accessible namespaces. Duplicates may occur in the list.
 * Route attributes:
 *   scope: team_data.member
 * @function Dropbox#teamNamespacesListContinue
 * @arg {TeamTeamNamespacesListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamNamespacesListResult>, DropboxResponseError.<TeamTeamNamespacesListContinueError>>}
 */
routes.teamNamespacesListContinue = function (arg, options) {
  return this.request('team/namespaces/list/continue', arg, 'team', 'api', 'rpc', 'team_data.member', options);
};

/**
 * Permission : Team member file access.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateAdd
 * @deprecated
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */
routes.teamPropertiesTemplateAdd = function (arg, options) {
  return this.request('team/properties/template/add', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Permission : Team member file access. The scope for the route is
 * files.team_metadata.write.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateGet
 * @deprecated
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */
routes.teamPropertiesTemplateGet = function (arg, options) {
  return this.request('team/properties/template/get', arg, 'team', 'api', 'rpc', 'files.team_metadata.write', options);
};

/**
 * Retrieves reporting data about a team's user activity. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetActivity
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGetActivityReport>, DropboxResponseError.<TeamDateRangeError>>}
 */
routes.teamReportsGetActivity = function (arg, options) {
  return this.request('team/reports/get_activity', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Retrieves reporting data about a team's linked devices. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetDevices
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGetDevicesReport>, DropboxResponseError.<TeamDateRangeError>>}
 */
routes.teamReportsGetDevices = function (arg, options) {
  return this.request('team/reports/get_devices', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Retrieves reporting data about a team's membership. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetMembership
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGetMembershipReport>, DropboxResponseError.<TeamDateRangeError>>}
 */
routes.teamReportsGetMembership = function (arg, options) {
  return this.request('team/reports/get_membership', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Retrieves reporting data about a team's storage usage. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetStorage
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamGetStorageReport>, DropboxResponseError.<TeamDateRangeError>>}
 */
routes.teamReportsGetStorage = function (arg, options) {
  return this.request('team/reports/get_storage', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Endpoint adds Approve List entries. Changes are effective immediately.
 * Changes are committed in transaction. In case of single validation error -
 * all entries are rejected. Valid domains (RFC-1034/5) and emails
 * (RFC-5322/822) are accepted. Added entries cannot overflow limit of 10000
 * entries per team. Maximum 100 entries per call is allowed.
 * Route attributes:
 *   scope: team_info.write
 * @function Dropbox#teamSharingAllowlistAdd
 * @arg {TeamSharingAllowlistAddArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistAddResponse>, DropboxResponseError.<TeamSharingAllowlistAddError>>}
 */
routes.teamSharingAllowlistAdd = function (arg, options) {
  return this.request('team/sharing_allowlist/add', arg, 'team', 'api', 'rpc', 'team_info.write', options);
};

/**
 * Lists Approve List entries for given team, from newest to oldest, returning
 * up to `limit` entries at a time. If there are more than `limit` entries
 * associated with the current team, more can be fetched by passing the returned
 * `cursor` to sharing_allowlist/list/continue.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamSharingAllowlistList
 * @arg {TeamSharingAllowlistListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistListResponse>, DropboxResponseError.<TeamSharingAllowlistListError>>}
 */
routes.teamSharingAllowlistList = function (arg, options) {
  return this.request('team/sharing_allowlist/list', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Lists entries associated with given team, starting from a the cursor. See
 * sharing_allowlist/list.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamSharingAllowlistListContinue
 * @arg {TeamSharingAllowlistListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistListResponse>, DropboxResponseError.<TeamSharingAllowlistListContinueError>>}
 */
routes.teamSharingAllowlistListContinue = function (arg, options) {
  return this.request('team/sharing_allowlist/list/continue', arg, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Endpoint removes Approve List entries. Changes are effective immediately.
 * Changes are committed in transaction. In case of single validation error -
 * all entries are rejected. Valid domains (RFC-1034/5) and emails
 * (RFC-5322/822) are accepted. Entries being removed have to be present on the
 * list. Maximum 1000 entries per call is allowed.
 * Route attributes:
 *   scope: team_info.write
 * @function Dropbox#teamSharingAllowlistRemove
 * @arg {TeamSharingAllowlistRemoveArgs} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistRemoveResponse>, DropboxResponseError.<TeamSharingAllowlistRemoveError>>}
 */
routes.teamSharingAllowlistRemove = function (arg, options) {
  return this.request('team/sharing_allowlist/remove', arg, 'team', 'api', 'rpc', 'team_info.write', options);
};

/**
 * Sets an archived team folder's status to active. Permission : Team member
 * file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderActivate
 * @arg {TeamTeamFolderIdArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderActivateError>>}
 */
routes.teamTeamFolderActivate = function (arg, options) {
  return this.request('team/team_folder/activate', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Sets an active team folder's status to archived and removes all folder and
 * file members. This endpoint cannot be used for teams that have a shared team
 * space. This route will either finish synchronously, or return a job ID and do
 * the async archive job in background. Please use team_folder/archive/check to
 * check the job status. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderArchive
 * @arg {TeamTeamFolderArchiveArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderArchiveLaunch>, DropboxResponseError.<TeamTeamFolderArchiveError>>}
 */
routes.teamTeamFolderArchive = function (arg, options) {
  return this.request('team/team_folder/archive', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Returns the status of an asynchronous job for archiving a team folder. The
 * job may show '.tag' as complete, but the team folder could still be in the
 * process of archiving (indicated by TeamFolderMetadata.status with
 * 'archive_in_progress'). To confirm that the team folder is fully archived,
 * check the field TeamFolderMetadata.status in the response for the value
 * 'archived'. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderArchiveCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderArchiveJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */
routes.teamTeamFolderArchiveCheck = function (arg, options) {
  return this.request('team/team_folder/archive/check', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Creates a new, active, team folder with no members. This endpoint can only be
 * used for teams that do not already have a shared team space. Permission :
 * Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderCreate
 * @arg {TeamTeamFolderCreateArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderCreateError>>}
 */
routes.teamTeamFolderCreate = function (arg, options) {
  return this.request('team/team_folder/create', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Retrieves metadata for team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderGetInfo
 * @arg {TeamTeamFolderIdListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Array.<TeamTeamFolderGetInfoItem>>, DropboxResponseError.<void>>}
 */
routes.teamTeamFolderGetInfo = function (arg, options) {
  return this.request('team/team_folder/get_info', arg, 'team', 'api', 'rpc', 'team_data.content.read', options);
};

/**
 * Lists all team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderList
 * @arg {TeamTeamFolderListArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderListResult>, DropboxResponseError.<TeamTeamFolderListError>>}
 */
routes.teamTeamFolderList = function (arg, options) {
  return this.request('team/team_folder/list', arg, 'team', 'api', 'rpc', 'team_data.content.read', options);
};

/**
 * Once a cursor has been retrieved from team_folder/list, use this to paginate
 * through all team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderListContinue
 * @arg {TeamTeamFolderListContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderListResult>, DropboxResponseError.<TeamTeamFolderListContinueError>>}
 */
routes.teamTeamFolderListContinue = function (arg, options) {
  return this.request('team/team_folder/list/continue', arg, 'team', 'api', 'rpc', 'team_data.content.read', options);
};

/**
 * Permanently deletes an archived team folder. This endpoint cannot be used for
 * teams that have a shared team space. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderPermanentlyDelete
 * @arg {TeamTeamFolderIdArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamTeamFolderPermanentlyDeleteError>>}
 */
routes.teamTeamFolderPermanentlyDelete = function (arg, options) {
  return this.request('team/team_folder/permanently_delete', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Changes an active team folder's name. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderRename
 * @arg {TeamTeamFolderRenameArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderRenameError>>}
 */
routes.teamTeamFolderRename = function (arg, options) {
  return this.request('team/team_folder/rename', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Sets an inactive team folder's status to active. Permission: Team member file
 * access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderRestore
 * @arg {TeamTeamFolderIdArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderRestoreError>>}
 */
routes.teamTeamFolderRestore = function (arg, options) {
  return this.request('team/team_folder/restore', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Updates the sync settings on a team folder or its contents.  Use of this
 * endpoint requires that the team has team selective sync enabled.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderUpdateSyncSettings
 * @arg {TeamTeamFolderUpdateSyncSettingsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderUpdateSyncSettingsError>>}
 */
routes.teamTeamFolderUpdateSyncSettings = function (arg, options) {
  return this.request('team/team_folder/update_sync_settings', arg, 'team', 'api', 'rpc', 'team_data.content.write', options);
};

/**
 * Returns the member profile of the admin who generated the team access token
 * used to make the call.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamTokenGetAuthenticatedAdmin
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamTokenGetAuthenticatedAdminResult>, DropboxResponseError.<TeamTokenGetAuthenticatedAdminError>>}
 */
routes.teamTokenGetAuthenticatedAdmin = function (options) {
  return this.request('team/token/get_authenticated_admin', null, 'team', 'api', 'rpc', 'team_info.read', options);
};

/**
 * Retrieves team events. If the result's GetTeamEventsResult.has_more field is
 * true, call get_events/continue with the returned cursor to retrieve more
 * entries. If end_time is not specified in your request, you may use the
 * returned cursor to poll get_events/continue for new events. Many attributes
 * note 'may be missing due to historical data gap'. Note that the
 * file_operations category and & analogous paper events are not available on
 * all Dropbox Business plans /business/plans-comparison. Use
 * features/get_values
 * /developers/documentation/http/teams#team-features-get_values to check for
 * this feature. Permission : Team Auditing.
 * Route attributes:
 *   scope: events.read
 * @function Dropbox#teamLogGetEvents
 * @arg {TeamLogGetTeamEventsArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamLogGetTeamEventsResult>, DropboxResponseError.<TeamLogGetTeamEventsError>>}
 */
routes.teamLogGetEvents = function (arg, options) {
  return this.request('team_log/get_events', arg, 'team', 'api', 'rpc', 'events.read', options);
};

/**
 * Once a cursor has been retrieved from get_events, use this to paginate
 * through all events. Permission : Team Auditing.
 * Route attributes:
 *   scope: events.read
 * @function Dropbox#teamLogGetEventsContinue
 * @arg {TeamLogGetTeamEventsContinueArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<TeamLogGetTeamEventsResult>, DropboxResponseError.<TeamLogGetTeamEventsContinueError>>}
 */
routes.teamLogGetEventsContinue = function (arg, options) {
  return this.request('team_log/get_events/continue', arg, 'team', 'api', 'rpc', 'events.read', options);
};

/**
 * Get a list of feature values that may be configured for the current account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersFeaturesGetValues
 * @arg {UsersUserFeaturesGetValuesBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<UsersUserFeaturesGetValuesBatchResult>, DropboxResponseError.<UsersUserFeaturesGetValuesBatchError>>}
 */
routes.usersFeaturesGetValues = function (arg, options) {
  return this.request('users/features/get_values', arg, 'user', 'api', 'rpc', 'account_info.read', options);
};

/**
 * Get information about a user's account.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#usersGetAccount
 * @arg {UsersGetAccountArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<UsersBasicAccount>, DropboxResponseError.<UsersGetAccountError>>}
 */
routes.usersGetAccount = function (arg, options) {
  return this.request('users/get_account', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Get information about multiple user accounts. At most 300 accounts may be
 * queried per request.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#usersGetAccountBatch
 * @arg {UsersGetAccountBatchArg} arg - The request parameters.
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<UsersGetAccountBatchError>>}
 */
routes.usersGetAccountBatch = function (arg, options) {
  return this.request('users/get_account_batch', arg, 'user', 'api', 'rpc', 'sharing.read', options);
};

/**
 * Get information about the current user's account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersGetCurrentAccount
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<UsersFullAccount>, DropboxResponseError.<void>>}
 */
routes.usersGetCurrentAccount = function (options) {
  return this.request('users/get_current_account', null, 'user', 'api', 'rpc', 'account_info.read', options);
};

/**
 * Get the space usage information for the current user's account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersGetSpaceUsage
 * @arg {Object} [options] - The request options.
 * @returns {Promise.<DropboxResponse<UsersSpaceUsage>, DropboxResponseError.<void>>}
 */
routes.usersGetSpaceUsage = function (options) {
  return this.request('users/get_space_usage', null, 'user', 'api', 'rpc', 'account_info.read', options);
};

export { routes };
